<mat-accordion #accordion="matAccordion" [multi]="true">

  <ng-template #mergeFieldHistory let-entry>
    <div class="merge-history" [class.own-history]="entry.isCreator" [class.expanded]="!entry.historyHasMore || isMergeHistoryExpanded(entry)">
      <div class="merge-history-title" *ngIf="!entry.isCreator"><mat-icon aria-hidden="true">edit</mat-icon><span><strong>{{ entry.sender }}</strong> {{ 'negotiate_contract.chat.fields_updated' | translate }}</span></div>
      <div *ngFor="let field of entry.mergeFields | slice:0:(isMergeHistoryExpanded(entry) ? entry.mergeFields.length : 10); let last = last" class="merge-history-field">
        <span class="merge-history-label" [title]="field.fieldName">{{ field.fieldName }}</span>
        <div class="merge-history-values">
          <span *ngIf="field.oldValue !== ''" class="merge-history-value" [title]="field.oldValue">{{ field.oldValue }}</span>
          <span *ngIf="field.oldValue !== ''" class="merge-history-arrow" [attr.aria-label]="'negotiate_contract.chat.changed_to' | translate">→</span>
          <span class="merge-history-value" [title]="field.newValue">{{ field.newValue }}</span>
          <button *ngIf="last && entry.historyHasMore && !isMergeHistoryExpanded(entry)" type="button" class="merge-history-more" aria-expanded="false" (click)="$event.stopPropagation(); toggleMergeHistory(entry)">
            <span *ngIf="entry.mergeFields.length > 10">… </span>{{ 'negotiate_contract.chat.show_more' | translate }}
          </button>
        </div>
      </div>
      <button *ngIf="entry.historyHasMore && isMergeHistoryExpanded(entry)" type="button" class="merge-history-more merge-history-collapse" aria-expanded="true" (click)="$event.stopPropagation(); toggleMergeHistory(entry)">
        {{ 'negotiate_contract.chat.show_less' | translate }}
      </button>
      <div *ngIf="entry.historyInvalid">{{ 'negotiate_contract.chat.history_unavailable' | translate }}</div>
    </div>
  </ng-template>

  <!-- thanh skeleton dung chung cho cac o text dang cho API (detail + list-user-sign) -->
  <ng-template #skeletonLine let-w>
    <span class="skeleton-text" [style.width.%]="w"></span>
  </ng-template>

  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="isNegotiate">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "negotiate_contract.label" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="chat-container">

      <!-- Danh sách tin nhắn -->
      <div class="message-list" #scrollContainer>
        <ng-container *ngIf="messages.length > 0; else noMessage" #messageItem>
          <div class="w-100 message-row d-flex" *ngFor="let msg of messages" (mouseenter)="isHover = msg.id" (mouseleave)="isHover = null" [ngClass]="msg.isCreator ? 'justify-content-end' : 'justify-content-start'">
            <div class="message position-relative" [class.merge-history-message]="msg.type === 2" [id]="'message-id-' +msg.id" [ngClass]="msg.isCreator ? 'me': 'notme'">
              <div class="sender fw-bold small mb-1" [hidden]="msg.isCreator">{{ msg.sender }}</div>
              <div class="reply-message-1  mb-2" *ngIf="msg.parent">
                <div class="reply-message-content" (click)="scrollToMessage(msg.parent)">
                  <div class="font-size-12">{{ msg.parent.isCreator ? ('negotiate_contract.chat.you' | translate) : msg.parent.sender}}</div>
                  <div class="bubble-reply" *ngIf="msg.parent.type !== 2">{{ msg.parent.content }}</div>
                  <div class="bubble-reply" *ngIf="msg.parent.type === 2">{{ msg.parent.historyInvalid ? ('negotiate_contract.chat.history_unavailable' | translate) : getNegotiateCopyText(msg.parent) }}</div>
                  <div *ngIf="msg.parent.attachments.length > 0" class="d-flex align-items-center message-file" style="margin: 0; padding: 0;">
                    <div style="width: 24px;">
                      <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                    </div>
                    <div style="width: 100%; flex: 1;">
                      <div style="font-size: 14px;" class="file-name">{{ msg.parent.attachments[0].fileName }}</div>
                      <div style="font-size: 11px;">{{formatFileSize(msg.parent.attachments[0].fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(msg.parent.attachments[0].fileName)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bubble" *ngIf="msg.type !== 2 && msg.content" [innerHTML]="msg.content | linkify"></div>
              <ng-container *ngIf="msg.type === 2" [ngTemplateOutlet]="mergeFieldHistory" [ngTemplateOutletContext]="{ $implicit: msg }"></ng-container>
              <div *ngIf="msg.attachments.length > 0">
                <div *ngFor="let file of msg.attachments" class="d-flex align-items-center message-file" (click)="downLoadFileNegotiate(file)" role="button" tabindex="0">
                  <div style="width: 24px;">
                    <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                  </div>
                  <div style="width: 100%; flex: 1;">
                    <div class="file-name">{{ file.fileName }}</div>
                    <div class="file-size">{{formatFileSize(file.fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(file.fileName)}}</div>
                  </div>
                </div>
              </div>
              <div class="time">{{ msg.createTime | date:'HH:mm dd/MM/yyyy' }}</div>
              <div class="position-absolute message-action" [hidden]="isHover !== msg.id && isActive !== msg.id">
                <button *ngIf="canReplyNegotiation" matTooltip="{{'negotiate_contract.chat.reply' | translate}}" mat-icon-button (click)="replyMessage(msg)">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="16" fill="#F5F5F5"/>
                    <path d="M10.1391 16.4051C9.97635 16.2656 9.89497 16.1959 9.86516 16.1129C9.83899 16.04 9.83899 15.9604 9.86516 15.8875C9.89497 15.8045 9.97635 15.7348 10.1391 15.5953L15.7862 10.7548C16.0664 10.5147 16.2065 10.3946 16.3251 10.3917C16.4281 10.3891 16.5266 10.4344 16.5917 10.5143C16.6667 10.6063 16.6667 10.7908 16.6667 11.1598V14.0233C18.0898 14.2723 19.3923 14.9934 20.3602 16.0761C21.4155 17.2565 21.9992 18.7842 22 20.3675V20.7755C21.3004 19.9328 20.427 19.2512 19.4395 18.7775C18.5689 18.3598 17.6277 18.1124 16.6667 18.0472V20.8406C16.6667 21.2096 16.6667 21.3941 16.5917 21.486C16.5266 21.566 16.4281 21.6112 16.3251 21.6087C16.2065 21.6057 16.0664 21.4857 15.7862 21.2455L10.1391 16.4051Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button matTooltip="{{'button.more_feature' | translate}}" *ngIf="getNegotiateCopyText(msg)" [matMenuTriggerFor]="menu" mat-icon-button class="btn-more" (menuOpened)="isActive = msg.id"
                (menuClosed)="isActive = null">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="16" fill="#F5F5F5"/>
                    <path d="M15.9993 16.6666C16.3675 16.6666 16.666 16.3681 16.666 15.9999C16.666 15.6317 16.3675 15.3333 15.9993 15.3333C15.6312 15.3333 15.3327 15.6317 15.3327 15.9999C15.3327 16.3681 15.6312 16.6666 15.9993 16.6666Z" stroke="#71717A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.666 16.6666C21.0342 16.6666 21.3327 16.3681 21.3327 15.9999C21.3327 15.6317 21.0342 15.3333 20.666 15.3333C20.2978 15.3333 19.9993 15.6317 19.9993 15.9999C19.9993 16.3681 20.2978 16.6666 20.666 16.6666Z" stroke="#71717A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.3327 16.6666C11.7009 16.6666 11.9993 16.3681 11.9993 15.9999C11.9993 15.6317 11.7009 15.3333 11.3327 15.3333C10.9645 15.3333 10.666 15.6317 10.666 15.9999C10.666 16.3681 10.9645 16.6666 11.3327 16.6666Z" stroke="#71717A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="copyMessage(getNegotiateCopyText(msg))">
                    <span class="fix-width">{{ 'button.copy' | translate }}</span>
                    <svg class="ml-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1511_3554)">
                      <path d="M4.16602 12.5001C3.38945 12.5001 3.00116 12.5001 2.69488 12.3732C2.2865 12.2041 1.96204 11.8796 1.79288 11.4712C1.66602 11.1649 1.66602 10.7767 1.66602 10.0001V4.33341C1.66602 3.39999 1.66602 2.93328 1.84767 2.57676C2.00746 2.26316 2.26243 2.00819 2.57603 1.8484C2.93255 1.66675 3.39926 1.66675 4.33268 1.66675H9.99935C10.7759 1.66675 11.1642 1.66675 11.4705 1.79362C11.8789 1.96277 12.2033 2.28723 12.3725 2.69561C12.4993 3.00189 12.4993 3.39018 12.4993 4.16675M10.166 18.3334H15.666C16.5994 18.3334 17.0661 18.3334 17.4227 18.1518C17.7363 17.992 17.9912 17.737 18.151 17.4234C18.3327 17.0669 18.3327 16.6002 18.3327 15.6667V10.1667C18.3327 9.23333 18.3327 8.76662 18.151 8.4101C17.9912 8.09649 17.7363 7.84153 17.4227 7.68174C17.0661 7.50008 16.5994 7.50008 15.666 7.50008H10.166C9.23259 7.50008 8.76588 7.50008 8.40937 7.68174C8.09576 7.84153 7.84079 8.09649 7.68101 8.4101C7.49935 8.76662 7.49935 9.23333 7.49935 10.1667V15.6667C7.49935 16.6002 7.49935 17.0669 7.68101 17.4234C7.84079 17.737 8.09576 17.992 8.40937 18.1518C8.76588 18.3334 9.2326 18.3334 10.166 18.3334Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1511_3554">
                      <rect width="20" height="20" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noMessage>
          <div style="margin: auto;">
            {{ 'negotiate_contract.chat.no_message' | translate }}
          </div>
        </ng-template>
      </div>



      <!-- Ô nhập tin nhắn + Gửi -->
      <div>
        <div class="reply-message" *ngIf="replyMessageData && canReplyNegotiation">
          <div class="reply-message-content">
            <div class="font-size-12">[{{'negotiate_contract.chat.reply' | translate}}] {{ replyMessageData.isCreator ? ('negotiate_contract.chat.you' | translate) : replyMessageData.sender}}</div>
            <div class="bubble-reply" *ngIf="replyMessageData.type !== 2" style="padding-right: 20px;">{{ replyMessageData.content }}</div>
            <div class="bubble-reply" *ngIf="replyMessageData.type === 2" style="padding-right: 20px;">{{ replyMessageData.historyInvalid ? ('negotiate_contract.chat.history_unavailable' | translate) : getNegotiateCopyText(replyMessageData) }}</div>
            <div *ngIf="replyMessageData.attachments.length > 0" class="d-flex align-items-center message-file">
              <div style="width: 24px;">
                <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
              </div>
              <div style="width: 100%; flex: 1;">
                <div class="file-name">{{ replyMessageData.attachments[0].fileName }}</div>
                <div class="font-size-12">{{formatFileSize(replyMessageData.attachments[0].fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(replyMessageData.attachments[0].fileName)}}</div>
              </div>
            </div>
            <button mat-icon-button class="clear-reply-btn" (click)="clearReplyMessageData()"><mat-icon>close</mat-icon></button>
          </div>
        </div>
        <div class="input-container d-flex align-items-center p-2 border-top position-relative" *ngIf="document.status == 1 && isComment">
          <div style="width: 34px; margin-left: 8px;">
            <button mat-icon-button (click)="fileInput.click()" matTooltip="{{ 'negotiate_contract.chat.attach' | translate }}">
              <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.825195" width="33.7153" height="33.7153" rx="16.8576" fill="#FDE6EB"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.222 9.80614C16.9813 7.16488 21.4428 7.16488 24.2022 9.80614C26.9788 12.464 26.9788 16.7865 24.2022 19.4444L16.7495 26.5782C14.7897 28.4542 11.6244 28.4542 9.66461 26.5782C7.68747 24.6857 7.68746 21.604 9.66461 19.7114L17.0101 12.6802C18.1704 11.5696 20.0393 11.5696 21.1996 12.6802C22.3773 13.8075 22.3773 15.6484 21.1996 16.7756L13.8006 23.8581C13.52 24.1267 13.0748 24.117 12.8062 23.8364C12.5377 23.5558 12.5474 23.1107 12.828 22.8421L20.2271 15.7596C20.8261 15.1861 20.8261 14.2697 20.2271 13.6963C19.6106 13.1062 18.5991 13.1062 17.9826 13.6963L10.6372 20.7275C9.23862 22.0662 9.23862 24.2234 10.6372 25.5622C12.0531 26.9175 14.361 26.9175 15.7769 25.5622L23.2296 18.4283C25.4277 16.3243 25.4277 12.9262 23.2296 10.8222C21.0141 8.70155 17.41 8.70155 15.1946 10.8222L9.18955 16.5703C8.90897 16.8389 8.4638 16.8292 8.19523 16.5486C7.92666 16.268 7.93639 15.8228 8.21697 15.5543L14.222 9.80614Z" fill="#EE0033"/>
              </svg>
            </button>
            <input #fileInput type="file" hidden (change)="onFileSelected($event)" multiple accept=".pdf,.jpg,.png,.bmp,.msg,.eml,.rtf,.doc,.docx,.xls,.xlsx,.jpeg"/>
          </div>
          <div class="send-message-container">
            <div class="w-full">
              <!-- File đính kèm -->
              <div *ngIf="fileList.length > 0" class="attached-files px-2 mb-2 d-flex overflow-auto custom-scrollbar">
                <div *ngFor="let file of fileList; let i = index" class="file-preview d-flex align-items-center p-2 mb-2 rounded">
                  <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                  <span matTooltip="{{ file.name }}" class="file-name">{{ truncateFileName(file.name) }}</span>
                  <button mat-icon-button (click)="removeFile(i)" class="ms-1 btn-remove-file"><mat-icon>close</mat-icon></button>
                </div>
              </div>
            </div>
            <div class="w-full d-flex align-items-center">
              <textarea #textAreaRef matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" [(ngModel)]="newMessage" maxlength="1000" rows="1"  (keydown.enter)="onKeyDown($event)" placeholder="{{'negotiate_contract.chat.hinttext' | translate}}" class="mx-2 input-send-message custom-scrollbar" autocomplete="off"></textarea>
              <button mat-icon-button (click)="sendMessage()" [disabled]="!newMessage.trim() && fileList.length === 0" class="btn-send-message" matTooltip="{{ 'negotiate_contract.chat.submit_comment' | translate }}">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [ngStyle]="{stroke: !newMessage.trim() && fileList.length === 0 ? 'rgb(181, 180, 180)' : '#CE002B' }" d="M20.5056 10.7754C21.1225 10.5355 21.431 10.4155 21.5176 10.2459C21.5926 10.099 21.5903 9.92446 21.5115 9.77954C21.4205 9.61226 21.109 9.50044 20.486 9.2768L4.59629 3.5728C4.0866 3.38983 3.83175 3.29835 3.66514 3.35605C3.52029 3.40621 3.40645 3.52004 3.35629 3.6649C3.29859 3.8315 3.39008 4.08635 3.57304 4.59605L9.277 20.4858C9.50064 21.1088 9.61246 21.4203 9.77973 21.5113C9.92465 21.5901 10.0991 21.5924 10.2461 21.5174C10.4157 21.4308 10.5356 21.1223 10.7756 20.5054L13.3724 13.8278C13.4194 13.707 13.4429 13.6466 13.4792 13.5957C13.5114 13.5506 13.5508 13.5112 13.5959 13.479C13.6468 13.4427 13.7072 13.4192 13.828 13.3722L20.5056 10.7754Z" stroke="#B5B4B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
  <hr *ngIf="isNegotiate">
  <!-- Thông tin tài liệu -->
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate">
    <mat-expansion-panel-header>
      <mat-panel-title class="document_info mat-panel-title">
        {{ "title.view_document_info" | translate }} {{ document.code }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <nz-table [nzShowPagination]="false" class="ant-table-no-border">
      <tbody>
        <tr>
          <td style="width: 180px">{{ "form.doc_code" | translate }}</td>
          <td class="font-weight-bold">
            <ng-container *ngIf="!isLoadingInfo; else skCode">{{ document.code }}</ng-container>
            <ng-template #skCode><span class="skeleton-text" style="width: 60%;"></span></ng-template>
          </td>
        </tr>
        <tr>
          <td>{{ "form.doc_name" | translate }}</td>
          <td class="font-weight-bold">
            <ng-container *ngIf="!isLoadingInfo; else skName">{{ document.name }}</ng-container>
            <ng-template #skName><span class="skeleton-text" style="width: 45%;"></span></ng-template>
          </td>
        </tr>
        <tr *ngIf="!this.isTakenSideView">
          <td>{{ "form.service_type" | translate }}</td>
          <td class="font-weight-bold d-flex align-items-center">
            <ng-container *ngIf="!isLoadingInfo; else skServiceType">{{ document.serviceType }}</ng-container>
            <ng-template #skServiceType><span class="skeleton-text" style="width: 40%;"></span></ng-template>
            <div nz-tooltip [nzTooltipTitle]="'contract_lot.contract_type_service_essential' | translate" class="ml-2">
              <i *ngIf="isEssential" style="font-size: 14px;" class="fa fa-star text-primary"></i>
            </div>
          </td>
        </tr>
        <tr *ngIf="!isNotAttestedUser && !isDocumentMoha && !isContractStandardized">
          <td>{{'contract_lot.identify_contract_BCT' | translate}}</td>
          <td class="font-weight-bold" *ngIf="isLoadingInfo"><span class="skeleton-text" style="width: 55%;"></span></td>
          <ng-container *ngIf="!isLoadingInfo">
            <td class="font-weight-bold" *ngIf="document.isConfirmBCT">{{'contract_lot.is_confirm_BCT' | translate}}</td>
            <td class="font-weight-bold" *ngIf="!document.isConfirmBCT">{{'contract_lot.is_not_confirm_BCT' | translate}}
            </td>
          </ng-container>
        </tr>
<!--        <tr *ngIf="documentReference.length > 0">-->
<!--          <td>{{ "form.doc_reference" | translate }}</td>-->
<!--          <td>-->
<!--            <div *ngFor="let item of documentReference">-->
<!--              <ins style="cursor: pointer" (click)="viewDocumentReference(item)"-->
<!--                matTooltip="{{ item.code }} - {{ item.name }}">-->
<!--                <em class="fa fa-file fa-fw text-primary"></em>-->
<!--                {{ item.code }} - {{ item.name }}-->
<!--              </ins>-->
<!--              &lt;!&ndash; <ins class="fix-width" style="cursor: pointer;" (click)="viewDocumentReference(item)"-->
<!--               matTooltip="{{item.code}} - {{item.name}}">-->
<!--            <em class="fa fa-file fa-fw text-primary"></em>-->
<!--            {{item.code }} - {{item.name}}-->
<!--          </ins> &ndash;&gt;-->
<!--            </div>-->
<!--          </td>-->
<!--        </tr>-->
        <tr *ngIf="document.expiredDate && !checkUrlDigital">
          <td>{{ "form.expired_date" | translate }}</td>
          <td class="font-weight-bold">
            {{ document.expiredDate | date: "dd/MM/yyyy" }}
          </td>
        </tr>
        <tr *ngIf="document.verifyPrice > 0 && isShowRetry && !isNotAttestedUser && !isContractStandardized">
          <td>{{ "form.total_money" | translate }}</td>
          <td class="font-weight-bold">
            <span>{{document.verifyPrice | number}} VNĐ</span>
            (<span style="cursor: pointer; text-decoration: underline; color: #1828ff;"
              (click)="openTimestampDialog()">{{"timestamp_detail.view_detail" | translate}}</span>)
          </td>
        </tr>
        <tr>
          <td>{{ "form.status" | translate }}</td>
          <td>
            <nz-tag *ngIf="isLoadingInfo"><span class="skeleton-text" style="width: 70px; display: inline-block;"></span></nz-tag>
            <ng-container *ngIf="!isLoadingInfo">
            <nz-tag *ngIf="document.status == enumContractStatus.DRAFT && !document.isTerminated">
              {{"search_form.draft" | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.PROCESSING && !isSetSignFlow && !document.isTerminated" [nzColor]="'blue'">
              {{ "search_form.processing" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.REJECTED && !document.isTerminated" [nzColor]="'red'">
              {{ "search_form.denied_sign" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.FINISHED && document.contractTerminationStatus !== 2 && document.contractTerminationStatus !== 4  && document.isTerminated == false" [nzColor]="'green'">
              {{ "search_form.finish" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == 8 && document.contractTerminationStatus !== 2 && document.contractTerminationStatus !== 4" [nzColor]="'green'">
              {{ "contract_share_partner.issued" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.CANCELLED && !document.isTerminated" [nzColor]="'red'">
              {{ "search_form.cancelled" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.PROCESSING && isSetSignFlow && !document.isTerminated" [nzColor]="'orange'">
              {{ "search_form.waiting_for_flow" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.CONNECTING && !document.isTerminated" [nzColor]="'blue'">
              {{ "search_form.connecting" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && !document.isTerminated" [nzColor]="'orange'">
              {{ "search_form.wait_confirm_enterprice_no_moit" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.FINISHED && document.contractTerminationStatus == 2 && !document.isTerminated" [nzColor]="'blue'">
              {{'contract_terminate.terminating' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.FINISHED && document.contractTerminationStatus == 4 && !document.isTerminated" [nzColor]="'green'">
              {{'contract_terminate.terminated' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.isTerminated == true" [nzColor]="'red'">
              {{'contract_terminate.terminated_contract' | translate}} </nz-tag>
            </ng-container>
          </td>
        </tr>

        <tr *ngIf="isDocumentMoha">
          <td>{{ "headertable.status_sign" | translate }}</td>
          <td>
              <nz-tag *ngIf="document.contractMohaConfirmStatus === 1" style="margin-right: 0px;">
                {{'contract_terminate.no_sign' | translate}}
              </nz-tag>
              <nz-tag *ngIf="document.contractMohaConfirmStatus === 2 || document.contractMohaConfirmStatus === 4" [nzColor]="'blue'" style="margin-right: 0px;">
                {{'contract_terminate.signing' | translate}}
              </nz-tag>
              <nz-tag *ngIf="document.contractMohaConfirmStatus === 3" [nzColor]="'red'" style="margin-right: 0px;">
                {{'contract_terminate.failed' | translate}}
              </nz-tag>
              <nz-tag *ngIf="document.contractMohaConfirmStatus === 5" [nzColor]="'red'" style="margin-right: 0px;">
                {{'search_form.cancelled' | translate}}
              </nz-tag>
              <div *ngIf="document.contractMohaConfirmStatus === 6" style="margin-right: 0px; display: flex; flex-direction: row; align-items: center;">
                <nz-tag [nzColor]="'green'" >
                  {{'contract_terminate.signed' | translate}}
                </nz-tag>
                <button mat-icon-button type="button" (click)="openPDFByBrowser()" *ngIf="isShowRetry"
                    appTrackEvent="w.btn.hdtoilap.tai_file">
                    <mat-icon style="color: #07736C;" matTooltip="{{'enterprise_contract.buttons.download_evidence' | translate}}">save_alt
                    </mat-icon>
                </button>
              </div>
          </td>
        </tr>

        <tr *ngIf="isDocumentMoha">
          <td>{{ "contract_terminate.status_send_up" | translate }}</td>
          <td>
            <nz-tag *ngIf="document.contractMohaStatus === 1" style="margin-right: 0px;">
              {{'contract_terminate.no_send' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.contractMohaStatus === 2" [nzColor]="'blue'" style="margin-right: 0px;">
              {{'contract_terminate.sending' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.contractMohaStatus === 3" [nzColor]="'red'" style="margin-right: 0px;">
              {{'sign_contract_flow.error' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.contractMohaStatus === 4" [nzColor]="'green'" style="margin-right: 0px;">
              {{'contract_terminate.sent' | translate}}
            </nz-tag>
          </td>
        </tr>

        <!-- Lý do -->
        <ng-container *ngIf="document.contractMohaErrorDescription">
          <tr>
            <td>{{ "header.reason" | translate }}</td>
            <td >
              {{ document.contractMohaErrorDescription }}
            </td>
          </tr>
        </ng-container>

        <!-- Mã chứng thực -->
        <ng-container *ngIf="document.messageAuthenCode">
          <tr>
            <td>{{ "headertable.code_sign" | translate }}</td>
            <td >
              {{ document.messageAuthenCode }}
            </td>
          </tr>
        </ng-container>

        <!--Thời gian chứng thực-->
        <ng-container *ngIf="document.messageAuthenDate">
          <tr>
            <td>{{ "headertable.time_sign" | translate }}</td>
            <td>
              {{ document.messageAuthenDate | date: "dd/MM/yyyy HH:mm:ss" }}
            </td>
          </tr>
        </ng-container>

        <ng-container *ngIf="document.contractMohaUuid">
          <tr>
            <td>{{ "headertable.uuid_contract" | translate }}</td>
            <td>
              {{document.contractMohaUuid}}
            </td>
          </tr>
          <tr *ngIf="document.formType === 'CONTRACT_APPENDIX'">
            <td>{{ "add_document_moha.edit_content" | translate }}</td>
            <td class="font-weight-bold">
              {{this.createContractMohaService.convertTitleContent(document.editProperty)}}
            </td>
          </tr>
        </ng-container>

        <!-- Thời gian gửi lên Nền tảng HĐLĐ -->
        <ng-container *ngIf="document.mohaSendTime">
          <tr>
            <td>{{ "headertable.time_send_sign" | translate }}</td>
            <td>
              {{ document.mohaSendTime |date: "dd/MM/yyyy HH:mm:ss" }}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="document.summary">
          <td>{{ "form.contract_summary" | translate }}</td>
          <td><div class="summaryText" style="overflow-wrap: anywhere;">{{  document.summary }}</div></td>
        </tr>
        <tr
          *ngIf="document.isConfirmBCT && document.status == enumContractStatus.FINISHED && cecaEnable && !isNotAttestedUser && !isContractStandardized">
          <td>{{ "ceca.lb_moit_status" | translate }}</td>
          <td class="d-flex">
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.DRAFT" [nzColor]="'blue'">
              {{ "search_form.processing" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.REJECTED" [nzColor]="'red'"
              style="margin-right: 0px;">
              {{ "search_form.rejected" | translate }}
            </nz-tag>
            <span class="ml-1" *ngIf="document.bctConfirmStatus === enumContractStatus.REJECTED  && expiredMoit">
              ({{"title.retry_expired_moit" | translate}})</span>

            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.FINISHED " [nzColor]="'green'">
              {{ "search_form.finish" | translate }}
          </nz-tag>

            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.CANCELLED" [nzColor]="'red'">
              {{ "search_form.cancelled" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.PROCESSING" [nzColor]="'blue'">
              {{ "search_form.processing" | translate }}
            </nz-tag>
          </td>
        </tr>

        <tr *ngIf="
            document.status == enumContractStatus.PROCESSING &&
            document.processDate
          ">
          <td>{{ "form.processing_term" | translate }}</td>
          <td class="font-weight-bold">
            {{ document.processDate | date: "HH:mm dd/MM/yyyy" }}
          </td>
        </tr>
        <tr *ngIf="
            document.status == enumContractStatus.CANCELLED &&
            document.cancelUserFullName &&
            document.cancelTime
          ">
          <td>{{ "search_form.user_cancel" | translate }}</td>
          <td>
            <strong>{{ document.cancelUserFullName }}</strong>
            {{ "search_form.at" | translate }}
            <strong>{{
              document.cancelTime | dateformat
              }}</strong>
          </td>
        </tr>
        <tr *ngIf="
            document.status == enumContractStatus.CANCELLED &&
            document.cancelReason
          ">
          <td>{{ "search_form.cancel_reason" | translate }}</td>
          <td><strong>{{ document.cancelReason }}</strong></td>
        </tr>
      </tbody>
    </nz-table>
  </mat-expansion-panel>

  <hr *ngIf="
      (document.contractAttachments.length > 0 ||
      document.newUploadContractAttachments.length > 0) && goFrom !== 'share'
    " />

  <!-- Hợp đồng lao động gốc -->
  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="listOriginalContact && listOriginalContact.length > 0 && goFrom !== 'share'">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "add_document_moha.original_employment_contract" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #editRowInternalTable nzBordered [nzData]="listOriginalContact" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
              "enterprise_contract.panel_document.table_users.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="70%">
            {{
              "form.digital_contract.document_information"
                | translate
            }}
          </th>
          <th class="text-center">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell d-flex align-items-center">
              <div class="row-icon" style="flex: 1; text-decoration: underline; color: #1828ff; cursor: pointer;" (click)="goToContractLiquidated(data.id)"> {{ data.code }}
                - {{ data.name }}
              </div>
            </div>
          </td>
          <!-- Action -->
          <td class="td-nz-icon text-center">
            <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id" aria-label="View" style="color: #07736C">
              <mat-icon>
                visibility
              </mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>
  <!-- Phụ lục hợp đồng -->
  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="document.contractAppendixDTOS && document.contractAppendixDTOS.length > 0 && goFrom !== 'share'">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "add_document_moha.list_pl_contract" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #editRowInternalTable nzBordered [nzData]="document.contractAppendixDTOS" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
              "enterprise_contract.panel_document.table_users.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="70%">
            {{
              "form.digital_contract.document_information"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
          <th class="text-center">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell d-flex align-items-center">
              <div class="row-icon" style="flex: 1; text-decoration: underline; color: #1828ff; cursor: pointer;" (click)="goToContractLiquidated(data.id)"> {{ data.code }}
                - {{ data.name }}
              </div>
            </div>
          </td>
          <!-- Trạng thái  -->
          <td class="text-center">
              <span *ngIf="data.status == 1 && !data.isTerminated">{{ 'search_form.draft' | translate}}</span>
              <span *ngIf="data.status == 2 && !data.isTerminated">{{ 'search_form.processing' | translate}}</span>
              <span *ngIf="data.status == 3 && !data.isTerminated">{{ 'search_form.denied_sign' | translate}}</span>
              <span *ngIf="data.status == 4 && !data.isTerminated">{{ 'search_form.finish' | translate}}</span>
              <span *ngIf="data.status == 5 && !data.isTerminated">{{ 'search_form.cancelled' | translate}}</span>
              <span *ngIf="data.status == 6 && !data.isTerminated">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
              <span *ngIf="data.status == 7 && !data.isTerminated">{{ 'contract_share_partner.issued' | translate}}</span>
              <span *ngIf="data.status == 8 && !data.isTerminated">{{ 'contract_share_partner.issued' | translate}}</span>
              <span *ngIf="data.status == 9 && !data.isTerminated">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
          </td>
          <!-- Action -->
          <td class="td-nz-icon text-center">
            <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id" aria-label="View" style="color: #07736C">
              <mat-icon>
                visibility
              </mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate" *ngIf="document.contractTerminations && document.contractTerminations.length > 0 && goFrom !== 'share' && !flagCopy">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ (document.formType == "CONTRACT_TERMINATION" ? "contract_terminate.contract_liquidated" : "contract_terminate.terminate") | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #contractTerminationsTable nzBordered [nzData]="document.contractTerminations" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
              "enterprise_contract.panel_document.table_users.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="70%">
            {{
              "form.digital_contract.document_information"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="100px" *ngIf="document.formType !== 'CONTRACT_TERMINATION'">{{ 'search_form.status' | translate}}</th>
          <th class="text-center">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of contractTerminationsTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell d-flex align-items-center">
              <div class="row-icon">
                <span style="color: blue; text-decoration: underline; cursor: pointer;" role="button" (click)="goToContractLiquidated(data.id)" target="_parent">{{ data.code }} - {{ data.name }}</span>
              </div>
            </div>
          </td>
          <td class="text-center" *ngIf="document.formType !== 'CONTRACT_TERMINATION'">
            <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
            <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
            <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
            <span *ngIf="data.status == 4">{{ 'search_form.finish' | translate}}</span>
            <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
            <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
            <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
            <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
            <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
          </td>
          <td class="td-nz-icon text-center">
            <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id" aria-label="View" style="color: #07736C">
              <mat-icon>
                visibility
              </mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>

  <!-- Cac ben khach hang ky ket ( chi rieng cho view_document_moha_digital)-->

  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate" *ngIf="checkMohaDigital">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.digital_contract.customer_parent" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #expandTable [nzData]="listOfMapDataCustomer" [nzFrontPagination]="false" [nzShowPagination]="false"
        class="ant-table-no-placeholder-border-bottom" nzBordered>
        <thead>
          <tr>
            <th class="text-center" nzWidth="40px">
              {{
              "enterprise_contract.panel_document_view.table_signing_flow.header.order"
              | translate
              }}
            </th>
            <th style="flex: 1;">
              {{
              "form.tbl_kyket"
              | translate
              }}
            </th>
            <!-- <th nzWidth="25%" class="text-center">
              {{
              "enterprise_contract.panel_document_view.table_signing_flow.header.progress"
              | translate
              }}
            </th> -->
            <th nzWidth="25px" style="flex: 1;"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of expandTable.data">
            <ng-container *ngFor="let item of mapOfExpandedData[data.key]">
              <tr
                *ngIf=" item.type == enumContractDetailType.ENTERPRISE && ((item.parent && item.parent.expand) || !item.parent)"
                class="tr-enterprise-data">
                <td class="text-center">{{ item.order }}</td>
                <td class="enterprise-name">{{ item.name }}</td>
                <!-- <td style="position: relative;" class="text-center">
                  <nz-tag *ngIf=" item.status == enumContractEnterpriseStatus.NO_PROCESS">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.waiting" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 !item.showNoFlowNotification" [nzColor]="'blue'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 !item.showNoFlowNotification">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 item.showNoFlowNotification && item.customerType !==10000" [nzColor]="'orange'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 item.showNoFlowNotification">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.REJECTED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.SIGNED" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.CANCELLED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.cancel_flow" |
                    translate}}
                  </nz-tag>

                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.DAEMON_PROCESSING)" [nzColor]="'orange'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing" |
                    translate}}
                  </nz-tag>

                  <div *ngIf="!isNotAttestedUser"
                    style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                    <div
                      *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                        <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                        <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div> -->
                  <!-- <nz-tag [nzColor]="'orange'"
                    *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</nz-tag>
            <nz-tag [nzColor]="'blue'"
                    *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && !item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</nz-tag> -->
                <!-- </td> -->
                <td (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
                </td>
              </tr>
              <tr
                *ngIf="item.type == enumContractDetailType.USER && ((item.parent && item.parent.expand) || !item.parent) && item.role !=3  "
                class="tr-user-data">
                <td *ngIf="(item.isSetUpSignFlowCreatedSide && !this.isTakenSideView) || !item.isSetUpSignFlowCreatedSide"></td>
                <td *ngIf="!item.isSetUpSignFlowCreatedSide" >{{ item.order }}. {{ item.name }} <span
                    *ngIf="item.departmentName">({{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.representative_name"
                    | translate}} {{item.departmentName}}
                    )</span>
                  <span *ngIf="(item.role == 2 ||item.role == 7) && item.isSignDigitalCertificate">
                    <img src="assets/images/certificate-diploma3.svg"
                      title="{{ 'enterprise_contract.panel_document.table_parties.header.tooltip_sig_cts' | translate }}"
                      style="width: 16px; height: 16px;">
                  </span>
                </td>
                <td *ngIf="item.isSetUpSignFlowCreatedSide && !this.isTakenSideView"  >
                  {{ item.order }}. {{ item.name }}</td>
                <td  style="position: relative;" class="text-center">
                  <nz-tag *ngIf="item.status == enumContractUserStatus.NO_PROCESS">
                    <!--                    <div *ngIf="item.role == enumContractUserRole.APPROVE">-->
                    <!--                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving_process" | translate}}-->
                    <!--                    </div>-->
                    <!--                    <div *ngIf="item.role == enumContractUserRole.SIGN">-->
                    <!--                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signing_process" | translate}}-->
                    <!--                    </div>-->
                    <!--                    <div *ngIf="item.role == enumContractUserRole.INITIAL">-->
                    <!--                      {{"enterprise_contract.pan el_document_view.table_signing_flow.user_status.initialling_process" | translate}}-->
                    <!--                    </div>-->
                    <div>
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.waiting" | translate}}
                    </div>
                  </nz-tag>
                  <nz-tag *ngIf="
                      document.status != enumContractStatus.REJECTED &&
                      document.status != enumContractStatus.CANCELLED &&
                      item.status == enumContractUserStatus.PROCESSING" [nzColor]="'blue'">
                    <div *ngIf="item.role == enumContractUserRole.APPROVE || item.role == 7">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.SIGN || item.role == 6">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signing" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.INITIAL">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling" |
                      translate}}
                    </div>
                  </nz-tag>

                  <nz-tag *ngIf="
                      document.status != enumContractStatus.REJECTED &&
                      document.status != enumContractStatus.CANCELLED &&
                      item.status == enumContractUserStatus.DAEMON_PROCESSING" [nzColor]="'orange'">
                    <div *ngIf="item.role == enumContractUserRole.APPROVE">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.SIGN">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.daemon_processing" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.INITIAL">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling" |
                      translate}}
                    </div>
                  </nz-tag>

                  <nz-tag *ngIf="
                      ((document.status === enumContractStatus.REJECTED ||
                        document.status === enumContractStatus.CANCELLED) &&
                      item.status == enumContractUserStatus.PROCESSING) || item.status === enumContractUserStatus.STOP_PROCESS">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.REJECTED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.denied" | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED &&
                     ( item.role == enumContractUserRole.APPROVE || item.role == 7 )" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approved" | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED &&
                                 ( item.role == enumContractUserRole.SIGN || item.role == 6 )" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signed" | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.CANCELLED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.cancel_flow" | translate}}
                  </nz-tag>
                  <div style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                    <div
                      *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                        <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                        <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="(item.isSetUpSignFlowCreatedSide && !this.isTakenSideView) || !item.isSetUpSignFlowCreatedSide" (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
                </td>
              </tr>
              <tr *ngIf="
                  item.type == enumContractDetailType.DETAIL &&
                  !item.showNoFlowNotification &&
                  ((item.parent && item.parent.expand) || !item.parent)
                ">
                <td></td>
                <td class="td-detail-data" colspan="2">
                  <span style=" word-break: break-word;" *ngIf="item.comment">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                      | translate
                    }}: {{ item.comment }}<br /></span>
                  <ng-container
                    *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1" style="color: green;">{{'enterprise_contract.status_success_OTP' |
                        translate}}</span>
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                        style="color: green;">{{'enterprise_contract.status_success_verify_subject' |
                        translate}}</span>
                    </div> -->
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1"
                        style="color: green;">{{'enterprise_contract.status_success_viettel' | translate}}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1" style="color: red;">{{'enterprise_contract.status_refused' |
                        translate}}</span>
                      </div>
                    <div *ngIf="isNotAttestedUser" style="padding-bottom: 0.5rem;">
                      {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                        style="color: red;">{{'enterprise_contract.status_refused_verify_subject' |
                        translate}}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)"
                  >
                    <span class="refusal">{{'enterprise_contract.reason_for_refusal' | translate}}: {{item.identityReason}}</span>
                  </ng-container>
                  <ng-container
                    class="refusal"
                    *ngIf="item.time && item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)"
                  >
                    <span class="refusal">{{"enterprise_contract.time_refusal" | translate }}: {{ item.time | dateformat }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: {{'enterprise_contract.status_pending_OTP' | translate}}
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}:
                      {{'enterprise_contract.status_pending_verify_subject' | translate}}
                    </div> -->
                  </ng-container>
                  <span *ngIf="item.role">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.role"
                    | translate
                    }}: {{
                    item.role == roleUser.CANCEL
                    ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_cancel"
                    | translate)
                    : item.role == roleUser.SIGN
                    ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_sign"
                    | translate)
                    : ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_approve"
                    | translate)
                    }}
                    <br /></span>
                  <span *ngIf="(item.role == 2 || item.role == 7) && item.isSignDigitalCertificate && !item?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                    | translate
                    }}: {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_no_image' | translate }}<br /></span>
                  <span *ngIf="(item.role == 2 || item.role == 7) && item.isSignDigitalCertificate && item?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                    | translate
                    }}: {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_image' | translate }}<br /></span>
                  <span style=" word-break: break-word;" *ngIf="item.taxCode">{{
                    "form.taxCode"| translate
                    }}: {{ item.taxCode }}<br /></span>
                  <!-- <span *ngIf="
                      item.time &&
                      (item.status == enumContractUserStatus.REJECTED ||
                        item.status == enumContractUserStatus.PROCESSED)
                    ">
                    {{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.time"
                    | translate
                    }}: {{ item.time | dateformat }}<br /></span> -->
                  <span *ngIf="item.certificateNo && !item.isSetUpSignFlow && (( !item.isCreatedSide && checkUSerCreateContract) || !checkUSerCreateContract)">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no"
                    | translate
                    }}: {{ item.certificateNo }}<br /></span>
                  <span *ngIf="item.contact">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.contact"
                    | translate
                    }}: {{ item.contact }}<br /></span>
                  <span *ngIf="item.userPosition">{{'form.userPosition' | translate}}: {{item.userPosition}}<br/></span>
                  <span *ngIf="
                      item.isSignedAnonymous &&
                      item.status == enumContractUserStatus.REJECTED
                    ">
                    {{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_reject_by_email"
                    | translate
                    }}
                    <br /></span>
                  <span *ngIf="
                      item.isSignedAnonymous &&
                      item.status == enumContractUserStatus.PROCESSED
                    ">
                    {{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_sign_by_email"
                    | translate
                    }}
                    <br /></span>
                  <span *ngIf="
                      item.establishSignNoLogin &&
                      !(
                        item.status == enumContractUserStatus.REJECTED ||
                        item.status == enumContractUserStatus.PROCESSED
                      )
                    ">
                    {{ (item.role == 7) ?
                    ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_appover_by_email"
                    | translate) :  ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_sign_by_email"
                      | translate)
                    }}
                    <br />
                  </span>
                  <span *ngIf="
                    item.establishSignNoLogin && checkUSerCreateContract &&
                    (
                      (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW || item.statusCe == enumContractEnterpriseStatus.PROCESSING) && !(document.status == enumContractStatus.REJECTED || document.status == enumContractStatus.CANCELLED)
                    )
                  " style="display: flex; align-items: center; padding-bottom: .5rem;">
                    {{ (item.role == 7) ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.appover_link" |
                    translate) : ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_link" |
                      translate)}}:&nbsp;
                    <div class="button-copy" (click)="copyLink(item)">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_6981_6211)">
                          <path d="M12.1484 20H4.6875C2.96432 20 1.5625 18.5982 1.5625 16.875V6.28906C1.5625 4.56589 2.96432 3.16406 4.6875 3.16406H12.1484C13.8716 3.16406 15.2734 4.56589 15.2734 6.28906V16.875C15.2734 18.5982 13.8716 20 12.1484 20ZM4.6875 4.72656C3.82599 4.72656 3.125 5.42755 3.125 6.28906V16.875C3.125 17.7365 3.82599 18.4375 4.6875 18.4375H12.1484C13.0099 18.4375 13.7109 17.7365 13.7109 16.875V6.28906C13.7109 5.42755 13.0099 4.72656 12.1484 4.72656H4.6875ZM18.3984 14.9219V3.125C18.3984 1.40182 16.9966 0 15.2734 0H6.60156C6.17004 0 5.82031 0.349731 5.82031 0.78125C5.82031 1.21277 6.17004 1.5625 6.60156 1.5625H15.2734C16.1349 1.5625 16.8359 2.26349 16.8359 3.125V14.9219C16.8359 15.3534 17.1857 15.7031 17.6172 15.7031C18.0487 15.7031 18.3984 15.3534 18.3984 14.9219Z" fill="white"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_6981_6211">
                            <rect width="20" height="20" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                      <span class="text-copy-button">{{'app_mobile.copy' | translate}}</span>
                    </div>
                    <br />
                  </span>
                  <!-- Hoàn tác số lần gửi OTP  -->
                  <span style="display: flex; align-items: center; padding-bottom: .5rem;"
                  *ngIf="(item.enterpriseId == enterpriseId || checkUSerCreateContract)
                  && (document.status != enumContractStatus.REJECTED &&
                  document.status != enumContractStatus.CANCELLED &&
                  (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                  !item.showNoFlowNotification)
                  && (item.customerType == 10000 || (item.customerType != 10000 && entType == 2 && !item.isBuyService && !item.isCreatedSide && ( !item.role || item.role == 1 || (item.isSignDigitalCertificate && item.role == 7 && item?.signConfig?.showImage))))
                  && isOtpLimited && isShowRetry
                  "
                  >
                    {{
                      "enterprise_contract.panel_document_view.table_signing_flow.detail_content.undo_number_otp"
                        | translate
                    }} &nbsp;
                    <div class="button-copy" (click)="undoNumberOtp(item)">
                      <span class="text-undo">{{
                        "enterprise_contract.panel_document_view.table_signing_flow.detail_content.undo"
                          | translate
                      }}</span>
                    </div>
                    <br />
                  </span>
                  <span *ngIf="item.signConfigEnterprise.showImage && !item.isCreatedSide && item.role !=1 && item.customerType !==10000">
                    {{
                      "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_sign_by_image"
                        | translate
                    }}
                    <br /></span>

                  <!-- Thông tin ký -->
                  <span *ngIf="item.signMethod != null && item.status == enumContractUserStatus.PROCESSED">
                    <span>{{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info" |
                      translate}}
                      :</span>

                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_USB_TOKEN" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_SIM_CA" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_sim_ca" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_SERVER" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_hsm" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_IMAGE" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_image" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc_advanced"
                      | translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC_ADVANCED" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc_advanced"
                      | translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.CLOUD_CA" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.EASY_CA" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_easy_ca" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.VNEID" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_vneid" |
                      translate}}
                    </span>
                    <span *ngIf=" item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.CLOUD_CA
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.EASY_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to" |
                      translate}}
                      :
                      {{ item.signMetadata.issuedTo }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.CLOUD_CA
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.EASY_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number" |
                      translate}}
                      :
                      {{ item.signMetadata.serialNumber }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.CLOUD_CA
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.EASY_CA) " class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no" |
                      translate}}
                      :
                      {{ item.signMetadata.certificateNo }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_OTP
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.phone_number" |
                      translate}}
                      :
                      {{ item.signMetadata.phoneNumber }}
                    </span>
                  </span>
                  <!-- END of Thông tin ký -->

                </td>
                <!-- <td>&nbsp;</td> -->
              </tr>
              <tr *ngIf="item.type == enumContractDetailType.DETAIL &&
                  item.showNoFlowNotification &&
                  ((item.parent && item.parent.expand) || !item.parent)
                ">
                <td></td>
                <td *ngIf="document.status != enumContractStatus.REJECTED" class="td-detail-data" colspan="2">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.wait_setup_flow"
                  | translate
                  }}
                </td>
                <td *ngIf="document.status === enumContractStatus.REJECTED" class="td-detail-data" colspan="2">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.partner_refuse"
                  | translate
                  }}
                </td>
                <td>&nbsp;</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </nz-table>
    </div>
  </mat-expansion-panel>

  <!---->

  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.contracting_parties" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #expandTable [nzData]="listOfMapData" [nzFrontPagination]="false" [nzShowPagination]="false"
        class="ant-table-no-placeholder-border-bottom" nzBordered>
        <thead>
          <tr>
            <th class="text-center" nzWidth="40px">
              {{
              "enterprise_contract.panel_document_view.table_signing_flow.header.order"
              | translate
              }}
            </th>
            <th>
              {{
              "enterprise_contract.panel_document_view.table_signing_flow.header.party_name"
              | translate
              }}
            </th>
            <th nzWidth="25%" class="text-center">
              {{
              "enterprise_contract.panel_document_view.table_signing_flow.header.progress"
              | translate
              }}
            </th>
            <th nzWidth="25px"></th>
          </tr>
        </thead>
        <tbody>
          <!-- skeleton: cac o text cua luong ky dang cho API list-user-sign -->
          <tr *ngIf="isLoadingParties">
            <td class="text-center"><span class="skeleton-text" style="width: 16px; display: inline-block;"></span></td>
            <td><span class="skeleton-text" style="width: 55%;"></span></td>
            <td class="text-center"><span class="skeleton-text" style="width: 80px; display: inline-block;"></span></td>
            <td></td>
          </tr>
          <ng-container *ngFor="let data of expandTable.data">
            <ng-container *ngFor="let item of mapOfExpandedData[data.key]">
              <tr
                *ngIf=" item.type == enumContractDetailType.ENTERPRISE && ((item.parent && item.parent.expand) || !item.parent)"
                class="tr-enterprise-data">
                <td class="text-center">{{ item.order }}</td>
                <td class="enterprise-name">{{ item.name }}</td>
                <td style="position: relative;" class="text-center">
                  <nz-tag *ngIf=" item.status == enumContractEnterpriseStatus.NO_PROCESS">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.waiting" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 !item.showNoFlowNotification" [nzColor]="'blue'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 !item.showNoFlowNotification">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 item.showNoFlowNotification && item.customerType !==10000" [nzColor]="'orange'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 item.showNoFlowNotification">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.REJECTED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.SIGNED" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.CANCELLED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.cancel_flow" |
                    translate}}
                  </nz-tag>

                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.DAEMON_PROCESSING)" [nzColor]="'orange'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing" |
                    translate}}
                  </nz-tag>

                  <div *ngIf="!isNotAttestedUser"
                    style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                    <div
                      *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                        <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                        <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <!-- <nz-tag [nzColor]="'orange'"
                    *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</nz-tag>
            <nz-tag [nzColor]="'blue'"
                    *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && !item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</nz-tag> -->
                </td>
                <td (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
                </td>
              </tr>
              <tr
                *ngIf="item.type == enumContractDetailType.USER && ((item.parent && item.parent.expand) || !item.parent) && item.role !=3  "
                class="tr-user-data">
                <td *ngIf="(item.isSetUpSignFlowCreatedSide && !this.isTakenSideView) || !item.isSetUpSignFlowCreatedSide"></td>
                <td *ngIf="!item.isSetUpSignFlowCreatedSide" >{{ item.order }}. {{ item.name }} <span
                    *ngIf="item.departmentName">({{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.representative_name"
                    | translate}} {{item.departmentName}}
                    )</span>
                  <span *ngIf="(item.role == 2 ||item.role == 7) && item.isSignDigitalCertificate">
                    <img src="assets/images/certificate-diploma3.svg"
                      title="{{ 'enterprise_contract.panel_document.table_parties.header.tooltip_sig_cts' | translate }}"
                      style="width: 16px; height: 16px;">
                  </span>
                </td>
                <td *ngIf="item.isSetUpSignFlowCreatedSide && !this.isTakenSideView"  >
                  {{ item.order }}. {{ item.name }}</td>
                <td  style="position: relative;" class="text-center">
                  <nz-tag *ngIf="item.status == enumContractUserStatus.NO_PROCESS">
                    <!--                    <div *ngIf="item.role == enumContractUserRole.APPROVE">-->
                    <!--                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving_process" | translate}}-->
                    <!--                    </div>-->
                    <!--                    <div *ngIf="item.role == enumContractUserRole.SIGN">-->
                    <!--                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signing_process" | translate}}-->
                    <!--                    </div>-->
                    <!--                    <div *ngIf="item.role == enumContractUserRole.INITIAL">-->
                    <!--                      {{"enterprise_contract.pan el_document_view.table_signing_flow.user_status.initialling_process" | translate}}-->
                    <!--                    </div>-->
                    <div>
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.waiting" | translate}}
                    </div>
                  </nz-tag>
                  <nz-tag *ngIf="
                      document.status != enumContractStatus.REJECTED &&
                      document.status != enumContractStatus.CANCELLED &&
                      item.status == enumContractUserStatus.PROCESSING" [nzColor]="'blue'">
                    <div *ngIf="item.role == enumContractUserRole.APPROVE || item.role == 7">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.SIGN || item.role == 6">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signing" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.INITIAL">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling" |
                      translate}}
                    </div>
                  </nz-tag>

                  <nz-tag *ngIf="
                      document.status != enumContractStatus.REJECTED &&
                      document.status != enumContractStatus.CANCELLED &&
                      item.status == enumContractUserStatus.DAEMON_PROCESSING" [nzColor]="'orange'">
                    <div *ngIf="item.role == enumContractUserRole.APPROVE">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.SIGN">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.daemon_processing" | translate}}
                    </div>
                    <div *ngIf="item.role == enumContractUserRole.INITIAL">
                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling" |
                      translate}}
                    </div>
                  </nz-tag>

                  <nz-tag *ngIf="
                      ((document.status === enumContractStatus.REJECTED ||
                        document.status === enumContractStatus.CANCELLED) &&
                      item.status == enumContractUserStatus.PROCESSING) || item.status === enumContractUserStatus.STOP_PROCESS">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.REJECTED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.denied" | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED &&
                     ( item.role == enumContractUserRole.APPROVE || item.role == 7 )" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approved" | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED &&
                                 ( item.role == enumContractUserRole.SIGN || item.role == 6 )" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signed" | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.CANCELLED" [nzColor]="'red'">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.cancel_flow" | translate}}
                  </nz-tag>
                  <div style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                    <div
                      *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                        <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                        <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="(item.isSetUpSignFlowCreatedSide && !this.isTakenSideView) || !item.isSetUpSignFlowCreatedSide" (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
                </td>
              </tr>
              <tr *ngIf="
                  item.type == enumContractDetailType.DETAIL &&
                  !item.showNoFlowNotification &&
                  ((item.parent && item.parent.expand) || !item.parent)
                ">
                <td></td>
                <td class="td-detail-data" colspan="2">
                  <span style=" word-break: break-word;" *ngIf="item.comment">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                      | translate
                    }}: {{ item.comment }}<br /></span>
                  <ng-container
                    *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1" style="color: green;">{{'enterprise_contract.status_success_OTP' |
                        translate}}</span>
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                        style="color: green;">{{'enterprise_contract.status_success_verify_subject' |
                        translate}}</span>
                    </div> -->
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1"
                        style="color: green;">{{'enterprise_contract.status_success_viettel' | translate}}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1" style="color: red;">{{'enterprise_contract.status_refused' |
                        translate}}</span>
                      </div>
                    <div *ngIf="isNotAttestedUser" style="padding-bottom: 0.5rem;">
                      {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                        style="color: red;">{{'enterprise_contract.status_refused_verify_subject' |
                        translate}}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)"
                  >
                    <span class="refusal">{{'enterprise_contract.reason_for_refusal' | translate}}: {{item.identityReason}}</span>
                  </ng-container>
                  <ng-container
                    class="refusal"
                    *ngIf="item.time && item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)"
                  >
                    <span class="refusal">{{"enterprise_contract.time_refusal" | translate }}: {{ item.time | dateformat }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: {{'enterprise_contract.status_pending_OTP' | translate}}
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}:
                      {{'enterprise_contract.status_pending_verify_subject' | translate}}
                    </div> -->
                  </ng-container>
                  <span *ngIf="item.role">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.role"
                    | translate
                    }}: {{
                    item.role == roleUser.CANCEL
                    ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_cancel"
                    | translate)
                    : item.role == roleUser.SIGN
                    ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_sign"
                    | translate)
                    : ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_approve"
                    | translate)
                    }}
                    <br /></span>
                  <span *ngIf="(item.role == 2 || item.role == 7) && item.isSignDigitalCertificate && !item?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                    | translate
                    }}: {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_no_image' | translate }}<br /></span>
                  <span *ngIf="(item.role == 2 || item.role == 7) && item.isSignDigitalCertificate && item?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                    | translate
                    }}: {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_image' | translate }}<br /></span>
                  <span style=" word-break: break-word;" *ngIf="item.taxCode">{{
                    "form.taxCode"| translate
                    }}: {{ item.taxCode }}<br /></span>
                  <span *ngIf="
                      item.time &&
                      (item.status == enumContractUserStatus.REJECTED ||
                        item.status == enumContractUserStatus.PROCESSED)
                    ">
                    {{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.time"
                    | translate
                    }}: {{ item.time | dateformat }}<br /></span>
                  <span *ngIf="item.certificateNo && !item.isSetUpSignFlow && (( !item.isCreatedSide && checkUSerCreateContract) || !checkUSerCreateContract)">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no"
                    | translate
                    }}: {{ item.certificateNo }}<br /></span>
                  <span *ngIf="item.contact">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.contact"
                    | translate
                    }}: {{ item.contact }}<br /></span>
                  <span *ngIf="item.userPosition">{{'form.userPosition' | translate}}: {{item.userPosition}}<br/></span>
                  <span *ngIf="
                      item.isSignedAnonymous &&
                      item.status == enumContractUserStatus.REJECTED
                    ">
                    {{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_reject_by_email"
                    | translate
                    }}
                    <br /></span>
                  <span *ngIf="
                      item.isSignedAnonymous &&
                      item.status == enumContractUserStatus.PROCESSED
                    ">
                    {{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_sign_by_email"
                    | translate
                    }}
                    <br /></span>
                  <span *ngIf="
                      item.establishSignNoLogin &&
                      !(
                        item.status == enumContractUserStatus.REJECTED ||
                        item.status == enumContractUserStatus.PROCESSED
                      )
                    ">
                    {{ (item.role == 7) ?
                    ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_appover_by_email"
                    | translate) :  ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_sign_by_email"
                      | translate)
                    }}
                    <br />
                  </span>
                  <span *ngIf="
                    item.establishSignNoLogin && checkUSerCreateContract &&
                    (
                      (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW || item.statusCe == enumContractEnterpriseStatus.PROCESSING) && !(document.status == enumContractStatus.REJECTED || document.status == enumContractStatus.CANCELLED)
                    )
                  " style="display: flex; align-items: center; padding-bottom: .5rem;">
                    {{ (item.role == 7) ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.appover_link" |
                    translate) : ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_link" |
                      translate)}}:&nbsp;
                    <div class="button-copy" (click)="copyLink(item)">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_6981_6211)">
                          <path d="M12.1484 20H4.6875C2.96432 20 1.5625 18.5982 1.5625 16.875V6.28906C1.5625 4.56589 2.96432 3.16406 4.6875 3.16406H12.1484C13.8716 3.16406 15.2734 4.56589 15.2734 6.28906V16.875C15.2734 18.5982 13.8716 20 12.1484 20ZM4.6875 4.72656C3.82599 4.72656 3.125 5.42755 3.125 6.28906V16.875C3.125 17.7365 3.82599 18.4375 4.6875 18.4375H12.1484C13.0099 18.4375 13.7109 17.7365 13.7109 16.875V6.28906C13.7109 5.42755 13.0099 4.72656 12.1484 4.72656H4.6875ZM18.3984 14.9219V3.125C18.3984 1.40182 16.9966 0 15.2734 0H6.60156C6.17004 0 5.82031 0.349731 5.82031 0.78125C5.82031 1.21277 6.17004 1.5625 6.60156 1.5625H15.2734C16.1349 1.5625 16.8359 2.26349 16.8359 3.125V14.9219C16.8359 15.3534 17.1857 15.7031 17.6172 15.7031C18.0487 15.7031 18.3984 15.3534 18.3984 14.9219Z" fill="white"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_6981_6211">
                            <rect width="20" height="20" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                      <span class="text-copy-button">{{'app_mobile.copy' | translate}}</span>
                    </div>
                    <br />
                  </span>
                  <!-- Hoàn tác số lần gửi OTP  -->
                  <span style="display: flex; align-items: center; padding-bottom: .5rem;"
                  *ngIf="(item.enterpriseId == enterpriseId || checkUSerCreateContract)
                  && (document.status != enumContractStatus.REJECTED &&
                  document.status != enumContractStatus.CANCELLED &&
                  (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                  !item.showNoFlowNotification)
                  && (item.customerType == 10000 || (item.customerType != 10000 && entType == 2 && !item.isBuyService && !item.isCreatedSide && ( !item.role || item.role == 1 || (item.isSignDigitalCertificate && item.role == 7 && item?.signConfig?.showImage))))
                  && isOtpLimited && isShowRetry
                  "
                  >
                    {{
                      "enterprise_contract.panel_document_view.table_signing_flow.detail_content.undo_number_otp"
                        | translate
                    }} &nbsp;
                    <div class="button-copy" (click)="undoNumberOtp(item)">
                      <span class="text-undo">{{
                        "enterprise_contract.panel_document_view.table_signing_flow.detail_content.undo"
                          | translate
                      }}</span>
                    </div>
                    <br />
                  </span>
                  <span *ngIf="item.signConfigEnterprise.showImage && !item.isCreatedSide && item.role !=1 && item.customerType !==10000">
                    {{
                      "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_sign_by_image"
                        | translate
                    }}
                    <br /></span>

                  <!-- Thông tin ký -->
                  <span *ngIf="item.signMethod != null && item.status == enumContractUserStatus.PROCESSED">
                    <span>{{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info" |
                      translate}}
                      :</span>

                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_USB_TOKEN" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_SIM_CA" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_sim_ca" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_SERVER" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_hsm" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_IMAGE" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_image" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc_advanced"
                      | translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC_ADVANCED" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc_advanced"
                      | translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.CLOUD_CA" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.EASY_CA" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_easy_ca" |
                      translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.VNEID" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_vneid" |
                      translate}}
                    </span>
                    <span *ngIf=" item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.CLOUD_CA
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.EASY_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to" |
                      translate}}
                      :
                      {{ item.signMetadata.issuedTo }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.CLOUD_CA
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.EASY_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number" |
                      translate}}
                      :
                      {{ item.signMetadata.serialNumber }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.CLOUD_CA
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.EASY_CA) " class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no" |
                      translate}}
                      :
                      {{ item.signMetadata.certificateNo }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_OTP
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.phone_number" |
                      translate}}
                      :
                      {{ item.signMetadata.phoneNumber }}
                    </span>
                  </span>
                  <!-- END of Thông tin ký -->

                </td>
                <td>&nbsp;</td>
              </tr>
              <tr *ngIf="item.type == enumContractDetailType.DETAIL &&
                  item.showNoFlowNotification &&
                  ((item.parent && item.parent.expand) || !item.parent)
                ">
                <td></td>
                <td *ngIf="document.status != enumContractStatus.REJECTED" class="td-detail-data" colspan="2">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.wait_setup_flow"
                  | translate
                  }}
                </td>
                <td *ngIf="document.status === enumContractStatus.REJECTED" class="td-detail-data" colspan="2">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.partner_refuse"
                  | translate
                  }}
                </td>
                <td>&nbsp;</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </nz-table>
    </div>
  </mat-expansion-panel>


  <hr />
  <!-- Danh sách chi sẻ đối tác ngoài -->
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate" *ngIf="document.contractSharePartners && document.contractSharePartners.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "contract_share_partner.share_contracts_with_partners" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #editRowInternalTable nzBordered [nzData]="document.contractSharePartners" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
              "enterprise_contract.panel_document.table_users.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="70%">
            {{
              "view_document_information.table_headers.signingApostropheContractUnit.member"
                | translate
            }}
          </th>
          <th class="text-center">
            {{
              "contract_share_partner.view_permission"
                | translate
            }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell d-flex align-items-center">
              <div style="margin-right: 12px;">
                <svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.4001 3.60005C5.4001 4.07744 5.21046 4.53528 4.87289 4.87284C4.53532 5.21041 4.07749 5.40005 3.6001 5.40005C3.12271 5.40005 2.66487 5.21041 2.32731 4.87284C1.98974 4.53528 1.8001 4.07744 1.8001 3.60005C1.8001 3.12266 1.98974 2.66482 2.32731 2.32726C2.66487 1.98969 3.12271 1.80005 3.6001 1.80005C4.07749 1.80005 4.53532 1.98969 4.87289 2.32726C5.21046 2.66482 5.4001 3.12266 5.4001 3.60005ZM10.2001 3.60005C10.2001 3.83643 10.1535 4.07049 10.0631 4.28888C9.97262 4.50727 9.84004 4.7057 9.67289 4.87284C9.50574 5.03999 9.30731 5.17257 9.08893 5.26303C8.87054 5.35349 8.63648 5.40005 8.4001 5.40005C8.16372 5.40005 7.92965 5.35349 7.71127 5.26303C7.49288 5.17257 7.29445 5.03999 7.12731 4.87284C6.96016 4.7057 6.82757 4.50727 6.73711 4.28888C6.64666 4.07049 6.6001 3.83643 6.6001 3.60005C6.6001 3.12266 6.78974 2.66482 7.12731 2.32726C7.46487 1.98969 7.92271 1.80005 8.4001 1.80005C8.87749 1.80005 9.33533 1.98969 9.67289 2.32726C10.0105 2.66482 10.2001 3.12266 10.2001 3.60005ZM7.7581 10.2C7.7857 10.0038 7.8001 9.80405 7.8001 9.60005C7.80149 8.65736 7.48434 7.74186 6.9001 7.00205C7.35615 6.73875 7.87348 6.60013 8.40008 6.60013C8.92668 6.60012 9.44401 6.73873 9.90006 7.00203C10.3561 7.26533 10.7348 7.64403 10.9981 8.10008C11.2615 8.55612 11.4001 9.07345 11.4001 9.60005V10.2H7.7581ZM3.6001 6.60005C4.39575 6.60005 5.15881 6.91612 5.72142 7.47873C6.28403 8.04134 6.6001 8.8044 6.6001 9.60005V10.2H0.600098V9.60005C0.600098 8.8044 0.916168 8.04134 1.47878 7.47873C2.04139 6.91612 2.80445 6.60005 3.6001 6.60005Z" fill="black"/>
                </svg>
              </div>
              <div class="row-icon"> {{ data.receiveName }} <span *ngIf="data.receiveEmail"> - {{ data.receiveEmail }}</span><span *ngIf="data.receivePhone"> - {{ data.receivePhone }}</span></div>
            </div>
          </td>
          <!-- Action -->
          <td class="word-break-line text-center">
            <div class="editable-cell">
              <div class="row-icon"*ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' | translate}}</div>
              <div class="row-icon" *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' | translate}}</div>
            </div>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>
  <!-- Danh sách chi sẻ đối tác ngoài -->
  <!-- Thông tin phê duyệt của đơn vị -->
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate" *ngIf="listDataApprover.length">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "approved.info_approved" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="table-enterprise-element">
      <nz-table #expandTableApprover [nzData]="listDataApprover" [nzFrontPagination]="false" [nzShowPagination]="false"
        class="ant-table-no-placeholder-border-bottom" nzBordered>
        <thead>
          <tr>
            <th class="text-center" nzWidth="40px">
              {{"approved.no" | translate }}
            </th>
            <th>
              {{"approved.approver" | translate}}
            </th>
            <th nzWidth="25%" class="text-center">
              {{"enterprise_contract.panel_document_view.table_signing_flow.header.progress" | translate }}
            </th>
            <th nzWidth="25px"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of expandTableApprover.data, index as i">
            <tr>
              <td class="text-center">{{i+1}}</td>
              <td class="font-weight-bold">{{data.fullName}} <span *ngIf=" data.isSignDigitalCertificate">
                    <img src="assets/images/certificate-diploma3.svg"
                         title="{{ 'enterprise_contract.panel_document.table_parties.header.tooltip_sig_cts' | translate }}"
                         style="width: 30px; height: 16px;">
                  </span></td>
              <td class="text-center">
                <nz-tag *ngIf="data?.status == enumApproverStatus.NO_PROCESS">
                  {{"forward_sign.status.no_process" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.PROCESSED" [nzColor]="'green'">
                  {{"forward_sign.status.processed" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.PROCESSING" [nzColor]="'blue'">
                  {{"forward_sign.status.processing" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.REJECTED" [nzColor]="'red'">
                  {{"forward_sign.status.rejected" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.STOP_PROCESS">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" | translate}}
                </nz-tag>
              </td>
              <td nzShowExpand [(nzExpand)]="mapOfExpandData[data.id]"></td>
            </tr>
            <tr [nzExpand]="mapOfExpandData[data.id]">
              <td>&nbsp;</td>
              <td class="td-detail-data" colspan="2">
                <span *ngIf="data.email">Email: {{data.email}}<br /></span>
                <span *ngIf="data.phoneNumber">{{"approved.phone_number" | translate }}: {{data.phoneNumber}} <br /></span>
                <span *ngIf="data.taxCode">{{"form.taxCode" | translate}}: {{data.taxCode}} <br /></span>
                <span *ngIf=" data.isSignDigitalCertificate && data?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                      | translate
                  }}
                  : {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_image' | translate }}<br /></span>
                <span *ngIf=" data.isSignDigitalCertificate && !data?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                      | translate
                  }}
                  : {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_no_image' | translate }}<br /></span>
                <span *ngIf="data?.processedAt &&data?.status == enumApproverStatus.PROCESSED  || data?.status == enumApproverStatus.REJECTED">{{"approved.processing_time" | translate}}: {{data.processedAt}}<br /></span>
                <span *ngIf="data?.reason && data?.status == enumApproverStatus.REJECTED">{{"approved.reject_reason" | translate}}: {{data.reason}}<br /></span>
                <span *ngIf="data?.reason && data?.status == enumApproverStatus.PROCESSED">{{"approved.approve_content" | translate}}: {{data.reason}}<br /></span>
              </td>
              <td>&nbsp;</td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </div>
  </mat-expansion-panel>

  <!-- Nz-table thiết lập luồng ký / duyệt-->
<!--  <mat-expansion-panel *ngIf="isSetSignFlow" class="mat-elevation-z0" expanded="true">-->
<!--    <mat-expansion-panel-header>-->
<!--      <mat-panel-title class="mat-panel-title font-color-blue">-->
<!--        {{ "form.order_of_approval_signing_contract_unit" | translate }}-->
<!--      </mat-panel-title>-->
<!--    </mat-expansion-panel-header>-->
<!--    <div style="text-align: right">-->
<!--      <button (click)="onSaveSignFlow()" *ngIf="listOfDataUserSign.length > 0" class="btn-save-flow" nz-button-->
<!--        nzType="primary">-->
<!--        {{ "button.save_flow" | translate }}-->
<!--      </button>-->
<!--    </div>-->
<!--    <form nz-form>-->
<!--      <nz-table #editRowTable [nzData]="listOfDataUserSign" [nzFrontPagination]="false" [nzShowPagination]="false"-->
<!--        class="ant-table-no-placeholder-border-bottom" nzBordered>-->
<!--        <thead>-->
<!--          <tr>-->
<!--            <th class="text-center" nzWidth="54px" style="min-width: 54px;">-->
<!--              {{-->
<!--              "enterprise_contract.panel_document.table_parties.header.order"-->
<!--              | translate-->
<!--              }}-->
<!--            </th>-->
<!--            <th class="text-center" nzWidth="62%">-->
<!--              {{-->
<!--              "enterprise_contract.panel_document.table_users.header.name"-->
<!--              | translate-->
<!--              }}-->
<!--            </th>-->
<!--            <th class="text-center">-->
<!--              {{-->
<!--              "enterprise_contract.panel_document.table_users.header.role"-->
<!--              | translate-->
<!--              }}-->
<!--            </th>-->
<!--            <th nzWidth="25px">&nbsp;</th>-->
<!--          </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--          <tr *ngFor="let data of editRowTable.data; let i = index" class="editable-row">-->
<!--            &lt;!&ndash; TT &ndash;&gt;-->
<!--            <td class="text-center">-->
<!--              <nz-input-number class="td-nz-input" [(ngModel)]="data.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1"-->
<!--              [ngModelOptions]="{ standalone: true }"></nz-input-number>-->
<!--            </td>-->
<!--            &lt;!&ndash; Tên &ndash;&gt;-->
<!--            <td>-->
<!--              <div *ngIf="data.userId != null" class="editable-cell">-->
<!--                {{ data.name }} - {{ data.email }}-->
<!--              </div>-->
<!--            </td>-->

<!--            &lt;!&ndash; Thực hiện &ndash;&gt;-->
<!--            <td class="text-center">-->
<!--              <div *ngIf="data.userId != null">-->
<!--                <nz-select [(ngModel)]="data.role" [ngModelOptions]="{ standalone: true }" style="width: 80%;" (ngModelChange)="changeRoleUserSign($event, data)">-->
<!--                  <nz-option [nzLabel]="'form.contract_approval' | translate" [nzValue]="'2'"></nz-option>-->
<!--                  <nz-option [nzLabel]="'form.contract_sign' | translate" [nzValue]="'1'"></nz-option>-->
<!--                </nz-select>-->
<!--                &lt;!&ndash; <span *ngIf="data.role == '2'">{{-->
<!--                  "form.contract_approval" | translate-->
<!--                  }}</span>-->
<!--                <span *ngIf="data.role == '1'">{{-->
<!--                  "form.contract_sign" | translate-->
<!--                  }}</span> &ndash;&gt;-->
<!--                &lt;!&ndash;                <nz-radio-group&ndash;&gt;-->
<!--                &lt;!&ndash;                  nzName="radiogroup{{ i }}"&ndash;&gt;-->
<!--                &lt;!&ndash;                  [(ngModel)]="data.role"&ndash;&gt;-->
<!--                &lt;!&ndash;                  [ngModelOptions]="{ standalone: true }"&ndash;&gt;-->
<!--                &lt;!&ndash;                >&ndash;&gt;-->
<!--                &lt;!&ndash;                  <label&ndash;&gt;-->
<!--                &lt;!&ndash;                    nz-radio&ndash;&gt;-->
<!--                &lt;!&ndash;                    nzValue="2"&ndash;&gt;-->
<!--                &lt;!&ndash;                    [nzDisabled]="true"&ndash;&gt;-->
<!--                &lt;!&ndash;                    class="nz-radio-customize-disable"&ndash;&gt;-->
<!--                &lt;!&ndash;                    >{{ "form.contract_approval" | translate }}</label&ndash;&gt;-->
<!--                &lt;!&ndash;                  >&ndash;&gt;-->
<!--                &lt;!&ndash;                  <label&ndash;&gt;-->
<!--                &lt;!&ndash;                    nz-radio&ndash;&gt;-->
<!--                &lt;!&ndash;                    nzValue="1"&ndash;&gt;-->
<!--                &lt;!&ndash;                    [nzDisabled]="true"&ndash;&gt;-->
<!--                &lt;!&ndash;                    class="nz-radio-customize-disable"&ndash;&gt;-->
<!--                &lt;!&ndash;                    >{{ "form.contract_sign" | translate }}</label&ndash;&gt;-->
<!--                &lt;!&ndash;                  >&ndash;&gt;-->
<!--                &lt;!&ndash;                </nz-radio-group>&ndash;&gt;-->
<!--              </div>-->
<!--            </td>-->

<!--            &lt;!&ndash; Action &ndash;&gt;-->
<!--            <td class="td-nz-icon text-center">-->
<!--              <a (nzOnConfirm)="onClickDeleteElementRecordUser(data)" *ngIf="data.userId != null" nz-popconfirm-->
<!--                nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}"-->
<!--                nzPopconfirmTitle="{{-->
<!--                  'popup.confirm_delete_user' | translate-->
<!--                }}">-->
<!--                &lt;!&ndash;                <i&ndash;&gt;-->
<!--                &lt;!&ndash;                  class="nz-icon-font"&ndash;&gt;-->
<!--                &lt;!&ndash;                  nz-icon&ndash;&gt;-->
<!--                &lt;!&ndash;                  nzType="close-square"&ndash;&gt;-->
<!--                &lt;!&ndash;                  nzTheme="outline"&ndash;&gt;-->
<!--                &lt;!&ndash;                  nz-tooltip&ndash;&gt;-->
<!--                &lt;!&ndash;                  nzTitle="{{ 'tooltips.delete' | translate }}"&ndash;&gt;-->
<!--                &lt;!&ndash;                ></i>&ndash;&gt;-->
<!--                <i aria-hidden="true" class="fa fa-trash" matTooltip="{{ 'tooltips.delete' | translate }}"></i>-->
<!--              </a>-->
<!--            </td>-->
<!--          </tr>-->
<!--          <tr class="editable-row">-->
<!--            &lt;!&ndash; TT &ndash;&gt;-->
<!--            <td class="text-center">&nbsp;</td>-->
<!--            &lt;!&ndash; Tên &ndash;&gt;-->
<!--            <td>-->
<!--              <div>-->
<!--                <nz-input-group [nzSuffix]="suffixUserInput">-->
<!--                  <input #autocompleteInput (input)="onChangeUserSignSearch($event.target?.value)"-->
<!--                    [(ngModel)]="inputUserValue" [ngModelOptions]="{ standalone: true }"-->
<!--                    [nzAutocomplete]="autoUserSearching" id="inputUser" nz-input-->
<!--                    placeholder="{{ 'placeholder.name_and_email' | translate }}" />-->
<!--                  <nz-autocomplete #autoUserSearching>-->
<!--                    <nz-auto-option (selectionChange)="autocompleteUserSelected($event, user)"-->
<!--                      *ngFor="let user of filteredUserOptions" [nzValue]="''">{{ user.name }}-->
<!--                      - -->
<!--                      {{ user.email }}</nz-auto-option>-->
<!--                  </nz-autocomplete>-->
<!--                </nz-input-group>-->
<!--                <ng-template #suffixUserInput>-->
<!--                  <nz-spin [nzIndicator]="indicatorUserInput" [nzSpinning]="isLoadUserSign" nzSimple></nz-spin>-->
<!--                  &lt;!&ndash; <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin> &ndash;&gt;-->
<!--                </ng-template>-->
<!--                <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"-->
<!--                    style="font-size: 24px"></i></ng-template>-->
<!--              </div>-->
<!--            </td>-->

<!--            &lt;!&ndash; Thực hiện &ndash;&gt;-->
<!--            &lt;!&ndash; <td class="text-center">-->
<!--          <div>-->
<!--            <nz-radio-group nzName="radiogroupDefault" [(ngModel)]="valueSelectedUserRole"-->
<!--              [ngModelOptions]="{ standalone: true }">-->
<!--              <label nz-radio nzValue="2">{{'form.contract_approval' | translate}}</label>-->
<!--              <label nz-radio nzValue="1">{{'form.contract_sign' | translate}}</label>-->
<!--            </nz-radio-group>-->
<!--          </div>-->
<!--        </td> &ndash;&gt;-->
<!--            <td class="text-center">&nbsp;</td>-->

<!--            &lt;!&ndash; Action &ndash;&gt;-->
<!--            <td class="td-nz-icon text-center">&nbsp;</td>-->
<!--          </tr>-->
<!--        </tbody>-->
<!--      </nz-table>-->
<!--      <mat-error *ngIf="isValidNoUserExist || isValidExistingSigning">-->
<!--        {{ "validation.error_user_no_set_up" | translate }}-->
<!--      </mat-error>-->
<!--    </form>-->
<!--  </mat-expansion-panel>-->


  <!-- Luồng thông tin ký xác nhận đơn vị -->
  <mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="!isNegotiate"
    *ngIf="checkShowBlockOtpUnit()">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.signed_information_unit" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element" *ngIf="document.userApproves && document.userApproves.length > 0">
      <nz-table #expandTableInformationSignedData [nzData]="listOfInformationSignedData" [nzFrontPagination]="false"
        [nzShowPagination]="false" class="ant-table-no-placeholder-border-bottom" nzBordered>
        <thead>
          <tr>
            <th>
              {{
              "enterprise_contract.panel_document_view.table_information_signed.header.member"
              | translate
              }}
            </th>
            <th nzWidth="25%" class="text-center">
              {{
              "enterprise_contract.panel_document_view.table_information_signed.header.progress"
              | translate
              }}
            </th>
            <th nzWidth="25px"></th>
          </tr>
        </thead>
        <tbody>
          <!-- <pre>{{expandTableInformationSignedData.data | json}}</pre> -->
          <ng-container *ngFor="let data of expandTableInformationSignedData.data">
            <ng-container *ngFor="let item of mapOfInformationSignedData[data.key]">
              <tr class="tr-enterprise-data hai" *ngIf="item.isParent">
                <td class="enterprise-name">{{ item.name }}</td>
                <td style="position: relative;" class="text-center">
                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                  document.status != enumContractStatus.CANCELLED &&
                  item.status == enumContractUserStatus.PROCESSED" [nzColor]="'green'">
                    {{"enterprise_contract.panel_document_view.table_information_signed.enterprise_status.signed" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                   document.status != enumContractStatus.CANCELLED &&
                                   item.status == enumContractUserStatus.PROCESSING" [nzColor]="'blue'">
                    {{"enterprise_contract.panel_document_view.table_information_signed.enterprise_status.processing" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 item.status == enumContractUserStatus.PROCESSING">
                    {{"enterprise_contract.panel_document_view.table_information_signed.enterprise_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <!-- <nz-tag *ngIf="item.status == enumContractUserStatus.CANCELLED" [nzColor]="'red'"> -->
                  <nz-tag *ngIf="item.status == enumContractUserStatus.CANCELLED">
                    {{"enterprise_contract.panel_document_view.table_information_signed.enterprise_status.stop_progress" |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="item.status == enumContractUserStatus.DAEMON_PROCESSING">
                    {{"enterprise_contract.panel_document_view.table_information_signed.enterprise_status.daemon_processing" |
                    translate}}
                  </nz-tag>
                </td>
                <td (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
                </td>
              </tr>
              <tr *ngIf="item.parent && item.parent.expand">
                <td class="td-detail-data" colspan="2">
                  <span>
                    {{
                    "enterprise_contract.panel_document_view.table_information_signed.sign_approves_content.role"
                    | translate
                    }}: {{ "enterprise_contract.panel_document_view.table_information_signed.sign_approves_content.sign_approve"
                    | translate }}<br /></span>
                  <span>
                    {{ "enterprise_contract.panel_document_view.table_information_signed.sign_approves_content.content" | translate }}: {{ item.createdTime }}<br /></span>
                  <span *ngIf="item.time && item.status == enumContractUserStatus.PROCESSED">
                    {{
                    "enterprise_contract.panel_document_view.table_information_signed.detail_content.time"
                    | translate
                    }}: {{ item.time }}<br /></span>
                  <ng-container *ngIf="item.status == enumContractUserStatus.CANCELLED">
                    <span *ngIf="item.reason" style="white-space: pre-line;">
                      {{ "enterprise_contract.panel_document_view.table_information_signed.sign_approves_content.reason_cancel" | translate }}: {{ item.reason }}<br /></span>
                    <span *ngIf="item.time">
                      {{ "enterprise_contract.panel_document_view.table_information_signed.sign_approves_content.time_cancel" | translate }}: {{ item.time }}<br /></span>
                  </ng-container>
                  <span *ngIf="item.contact">{{
                    "enterprise_contract.panel_document_view.table_information_signed.detail_content.contact"
                    | translate
                    }}
                    : {{ item.contact }}<br /></span>
                  <span *ngIf="item.userPosition">{{'form.userPosition' | translate}}: {{item.userPosition}}<br/></span>
                </td>
                <td>&nbsp;</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </nz-table>
    </div>
    <div *ngIf="!document.userApproves || document.userApproves.length === 0">
      {{ "enterprise_contract.panel_document_view.table_information_signed.have_no_signer"
      | translate }}
    </div>
  </mat-expansion-panel>

  <!-- End Nz-table set luồng ký / duyệt-->

  <hr *ngIf="!isSetSignFlow && listInitial.length > 0" />

  <!-- Nz-table danh sách ký nháy-->
  <mat-expansion-panel *ngIf="!isSetSignFlow && listInitial.length > 0" class="mat-elevation-z0" [expanded]="!isNegotiate">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.contract_signature_information_of_the_unit" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <nz-table #initialTable [nzData]="listOfMapInitialData" class="ant-table-no-placeholder-border-bottom" nzBordered
      nzShowPagination="false">
      <thead>
        <tr>
          <th class="text-center" nzWidth="40px">
            {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.order"
            | translate
            }}
          </th>
          <th>
            {{
            "enterprise_contract.panel_document.table_users.header.name"
            | translate
            }}
          </th>
          <th class="text-center" nzWidth="25%">
            {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.progress"
            | translate
            }}
          </th>
          <th nzWidth="30px"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of initialTable.data">
          <ng-container *ngFor="let item of mapOfInitialData[data.key]">
            <tr *ngIf="
                item.type == enumContractDetailType.USER &&
                ((item.parent && item.parent.expand) || !item.parent)
              " class="tr-user-data">
              <!-- TT -->
              <td class="text-center">{{ item.order }} </td>
              <!-- Tên -->
              <td>
                <div class="editable-cell">
                  <b>{{ item.name }}</b>
                </div>
              </td>
              <td class="text-center">
                <nz-tag *ngIf="item.status == enumContractUserStatus.NO_PROCESS">
                  <!-- {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.waiting"
                  | translate
                  }} -->
                  {{
                    "enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress"
                    | translate
                    }}
                </nz-tag>
                <nz-tag
                  *ngIf="document.status !== enumContractStatus.PROCESSING && item.status == enumContractUserStatus.PROCESSING">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress"
                  | translate
                  }}
                </nz-tag>
                <nz-tag
                  *ngIf="document.status == enumContractStatus.PROCESSING && item.status == enumContractUserStatus.PROCESSING"
                  [nzColor]="'blue'">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling"
                  | translate
                  }}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractUserStatus.REJECTED" [nzColor]="'red'">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.denied"
                  | translate
                  }}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED" [nzColor]="'green'">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.initialled"
                  | translate
                  }}
                </nz-tag>
              </td>
              <td (nzExpandChange)="
                  collapse(mapOfInitialData[data.key], item, $event)
                " [(nzExpand)]="item.expand" [nzShowExpand]="!!item.children"></td>
            </tr>
            <tr *ngIf="
                item.type == enumContractDetailType.DETAIL &&
                ((item.parent && item.parent.expand) || !item.parent)
              ">
              <td></td>
              <td class="td-detail-data" colspan="2">
                <span *ngIf="item.comment"><br />{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                  | translate
                  }}
                  : {{ item.comment }}<br /></span>
                <span *ngIf="
                    item.time &&
                    (item.status == enumContractUserStatus.REJECTED ||
                      item.status == enumContractUserStatus.PROCESSED)
                  ">
                  {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.time"
                  | translate
                  }}: {{ item.time | dateformat }}<br /></span>
                <span *ngIf="item.contact">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.contact"
                  | translate
                  }}
                  : {{ item.contact }}<br /></span>
                <span *ngIf="item.userPosition">{{'form.userPosition' | translate}}: {{item.userPosition}}<br/></span>
              </td>
              <td>&nbsp;</td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </nz-table>
  </mat-expansion-panel>
  <!-- End Nz-table danh sách ký nháy-->

  <!-- <hr *ngIf="!isSetSignFlow && listInitial.length > 0"/> -->
  <hr />
  <!-- Nz-table danh sách cuyen tiep-->
  <!-- <mat-expansion-panel
    expanded="true"
    class="mat-elevation-z0"
    *ngIf="!isSetSignFlow && listInitial.length > 0"
  > -->
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate"
    *ngIf="document.createdBy === userLoginId && listOfDataUserForward.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.list_auto_forward_contract" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <nz-table #DataUserForward [nzData]="listOfDataUserForward" class="ant-table-no-placeholder-border-bottom"
      nzBordered nzShowPagination="false">
      <thead>
        <tr>
          <th class="text-center" nzWidth="40px">
            {{
            "enterprise_contract.panel_document_view.table_user_forward.no"
            | translate
            }}
          </th>
          <th>
            {{
            "enterprise_contract.panel_document_view.table_user_forward.member"
            | translate
            }}
          </th>
          <th class="text-center" nzWidth="25%">
            {{
            "enterprise_contract.panel_document_view.table_user_forward.result"
            | translate
            }}
          </th>
          <th class="text-center" *ngIf="!isAllContractShareDone && document.status === 4" nzWidth="20%"> {{
            "enterprise_contract.panel_document_view.table_user_forward.action"
            | translate
            }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of DataUserForward.data; index as index">
          <tr class="tr-user-data">
            <!-- TT -->
            <td class="text-center">{{ index + 1 }}</td>
            <!-- Tên -->
            <td>
              <div class="editable-cell">
                <div *ngIf="data.type === 'DEPARTMENT'" class="row-icon department">{{ data.departmentCode }} - {{ data.departmentName }}</div>
                <div class="row-icon user"
                  *ngIf="(data.type === 'DEPARTMENT' && data.representativeId) || data.type === 'USER'"
                  [class.disabled]="!data.representativeIsActive && data.type === 'DEPARTMENT'">
                  {{data.name ? data.name : data.receiveName}} - {{data.email ? data.email : data.receiveEmail}}
                  <span *ngIf="!data.representativeIsActive && data.type === 'DEPARTMENT'">{{"enterprise_contract.panel_document.table_users.representative_inactive" | translate }}</span>
                  <span *ngIf="data.userPosition"> - {{data.userPosition}}</span>
                </div>
                <div class="row-icon disabled user"
                  *ngIf="!data.representativeId && data.type === 'DEPARTMENT'">
                  {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                </div>
              </div>
            </td>
            <td class="text-center">
              <div *ngIf="document.status === 4">
                <nz-tag *ngIf="data.status === 'PROCESSING'" [nzColor]="'blue'">
                  {{
                  "enterprise_contract.panel_document_view.table_user_forward.processing"
                  | translate
                  }}
                </nz-tag>
                <nz-tag *ngIf="data.status === 'FAILED'" [nzColor]="'red'">
                  {{
                  "enterprise_contract.panel_document_view.table_user_forward.false"
                  | translate
                  }}
                </nz-tag>
                <nz-tag *ngIf="data.status === 'SUCCESS'" [nzColor]="'green'">
                  {{
                  "enterprise_contract.panel_document_view.table_user_forward.success"
                  | translate
                  }}
                </nz-tag>
              </div>
            </td>
            <td *ngIf="!isAllContractShareDone && document.status === 4">
              <div *ngIf="data.status === 'FAILED'" class="text-center d-flex justify-content-around">
                <a (click)="openPopupforwardContract(data)">
                  <i aria-hidden="true" class="fa fa-paper-plane" matTooltip="{{ 'tooltips.forward' | translate }}"
                    style="color: #07746C"></i>
                </a>

                <a class="text-danger">
                  <i aria-hidden="true" class="fa fa-warning"
                    matTooltip="{{ 'messages.' + data.errorReason | translate}}"></i>
                </a>
              </div>
            </td>
          </tr>

        </ng-container>
      </tbody>
    </nz-table>
  </mat-expansion-panel>
  <!-- End Nz-table danh sách chuyen tiep-->

  <!-- Danh sách tệp đính kèm -->
  <!-- BEGIN: Updated for change request SCONTRACT-5260 and reverted previous version-->
  <mat-expansion-panel class="mat-elevation-z0" expanded="false" *ngIf="
      (document.contractAttachments.length > 0 ||
      document.newUploadContractAttachments.length > 0) && goFrom !== 'share'
    ">
    <!-- <hr> -->
    <mat-expansion-panel-header>
      <mat-panel-title class="document_info mat-panel-title">
        {{ "form.attach_file_list" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- Customer's attachments -->
    <div class="mt-2 fix-width d-flex" *ngFor="let item of document.contractAttachments">
      <a (click)="downloadFile(item.id, item.fileName)" style="width: 90%;" class="text-truncate">
        <em class="fa fa-download fa-fw text-primary" matTooltip="{{ 'tooltips.download' | translate }}"></em>
        <span [matTooltip]="item.fileName"> {{ item.fileName }}</span>
      </a>
      <span style="width: 10%;" *ngIf="showIconAttachment">
        <svg style="outline: none;" *ngIf="item.allow == 'EXTERNAL'" matTooltip="{{('permission_attachment.config_permission' | translate) + ': ' + ('permission_attachment.all_parties_involved' | translate)}}" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.8778 11.1879C12.4867 10.7965 12.0297 10.477 11.5278 10.2441C12.2356 9.6707 12.6872 8.7957 12.6872 7.81445C12.6872 6.0832 11.2434 4.66289 9.51217 4.68945C7.80749 4.71602 6.43405 6.10508 6.43405 7.81445C6.43405 8.7957 6.88717 9.6707 7.59342 10.2441C7.0914 10.4768 6.63439 10.7963 6.24342 11.1879C5.3903 12.0426 4.90592 13.1707 4.87467 14.3738C4.87426 14.3905 4.87718 14.4071 4.88328 14.4226C4.88937 14.4382 4.89851 14.4523 4.91016 14.4642C4.92181 14.4762 4.93573 14.4857 4.95111 14.4921C4.96648 14.4986 4.98299 14.502 4.99967 14.502H5.87467C5.94186 14.502 5.99811 14.4488 5.99967 14.3816C6.02936 13.4754 6.39655 12.627 7.04186 11.9832C7.37208 11.6512 7.76486 11.388 8.19747 11.2089C8.63008 11.0297 9.09393 10.9381 9.56217 10.9395C10.5137 10.9395 11.409 11.3098 12.0825 11.9832C12.7262 12.627 13.0934 13.4754 13.1247 14.3816C13.1262 14.4488 13.1825 14.502 13.2497 14.502H14.1247C14.1414 14.502 14.1579 14.4986 14.1732 14.4921C14.1886 14.4857 14.2025 14.4762 14.2142 14.4642C14.2258 14.4523 14.235 14.4382 14.2411 14.4226C14.2472 14.4071 14.2501 14.3905 14.2497 14.3738C14.2184 13.1707 13.734 12.0426 12.8778 11.1879ZM9.56217 9.81445C9.0278 9.81445 8.52467 9.60664 8.14811 9.22852C7.95913 9.04103 7.80985 8.81739 7.70918 8.57095C7.60852 8.32451 7.55852 8.06032 7.56217 7.79414C7.56686 7.28164 7.77155 6.78633 8.12936 6.41914C8.50436 6.03477 9.00592 5.8207 9.54186 5.81445C10.0715 5.80977 10.5856 6.01602 10.9637 6.38633C11.3512 6.76602 11.5637 7.27383 11.5637 7.81445C11.5637 8.34883 11.3559 8.85039 10.9778 9.22852C10.7923 9.41492 10.5717 9.56268 10.3287 9.66325C10.0857 9.76383 9.82515 9.81522 9.56217 9.81445ZM5.64811 8.22695C5.63405 8.09102 5.62624 7.95352 5.62624 7.81445C5.62624 7.56602 5.64967 7.32383 5.69342 7.08789C5.70436 7.03164 5.67467 6.97383 5.62311 6.95039C5.41061 6.85508 5.2153 6.72383 5.04655 6.5582C4.8477 6.3654 4.69123 6.13327 4.58712 5.87661C4.483 5.61996 4.43353 5.34442 4.44186 5.06758C4.45592 4.56602 4.65749 4.08945 5.00905 3.73008C5.39499 3.33477 5.91374 3.11914 6.4653 3.12539C6.96374 3.13008 7.44499 3.32227 7.80905 3.66289C7.93249 3.77852 8.03874 3.90664 8.1278 4.04414C8.15905 4.09258 8.21999 4.11289 8.27311 4.09414C8.54811 3.99883 8.83874 3.93164 9.13717 3.90039C9.22467 3.89102 9.27467 3.79727 9.23561 3.71914C8.7278 2.71445 7.6903 2.0207 6.4903 2.00195C4.75749 1.97539 3.31374 3.3957 3.31374 5.12539C3.31374 6.10664 3.7653 6.98164 4.47311 7.55508C3.97624 7.78477 3.51842 8.10195 3.12155 8.49883C2.2653 9.35352 1.78092 10.4816 1.74967 11.6863C1.74926 11.703 1.75218 11.7196 1.75828 11.7351C1.76437 11.7507 1.77351 11.7648 1.78516 11.7767C1.79681 11.7887 1.81073 11.7982 1.8261 11.8046C1.84148 11.8111 1.85799 11.8145 1.87467 11.8145H2.75124C2.81842 11.8145 2.87467 11.7613 2.87624 11.6941C2.90592 10.7879 3.27311 9.93945 3.91842 9.2957C4.3778 8.83633 4.9403 8.51758 5.55436 8.36289C5.6153 8.34727 5.65592 8.28945 5.64811 8.22695Z" fill="black" fill-opacity="0.88"/>
        </svg>
        <svg style="outline: none;" *ngIf="item.allow == 'INTERNAL'" matTooltip="{{('permission_attachment.config_permission' | translate) + ': ' + ('permission_attachment.internal_documents' | translate)}}" [ngStyle]="{'fill': '#000000E0'}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.4141 11.9312C13.1194 11.2331 12.6916 10.5989 12.1547 10.0641C11.6195 9.52767 10.9854 9.10001 10.2875 8.80469C10.2813 8.80156 10.275 8.8 10.2688 8.79688C11.2422 8.09375 11.875 6.94844 11.875 5.65625C11.875 3.51562 10.1407 1.78125 8.00004 1.78125C5.85941 1.78125 4.12504 3.51562 4.12504 5.65625C4.12504 6.94844 4.75785 8.09375 5.73129 8.79844C5.72504 8.80156 5.71879 8.80312 5.71254 8.80625C5.01254 9.10156 4.38441 9.525 3.84535 10.0656C3.30896 10.6009 2.8813 11.235 2.58598 11.9328C2.29585 12.616 2.13939 13.3485 2.12504 14.0906C2.12462 14.1073 2.12755 14.1239 2.13364 14.1394C2.13974 14.1549 2.14888 14.1691 2.16053 14.181C2.17218 14.193 2.1861 14.2025 2.20147 14.2089C2.21684 14.2154 2.23336 14.2188 2.25004 14.2188H3.18754C3.25629 14.2188 3.31098 14.1641 3.31254 14.0969C3.34379 12.8906 3.82816 11.7609 4.68441 10.9047C5.57035 10.0188 6.74691 9.53125 8.00004 9.53125C9.25316 9.53125 10.4297 10.0188 11.3157 10.9047C12.1719 11.7609 12.6563 12.8906 12.6875 14.0969C12.6891 14.1656 12.7438 14.2188 12.8125 14.2188H13.75C13.7667 14.2188 13.7832 14.2154 13.7986 14.2089C13.814 14.2025 13.8279 14.193 13.8396 14.181C13.8512 14.1691 13.8603 14.1549 13.8664 14.1394C13.8725 14.1239 13.8755 14.1073 13.875 14.0906C13.8594 13.3438 13.7047 12.6172 13.4141 11.9312ZM8.00004 8.34375C7.28285 8.34375 6.60785 8.06406 6.10004 7.55625C5.59223 7.04844 5.31254 6.37344 5.31254 5.65625C5.31254 4.93906 5.59223 4.26406 6.10004 3.75625C6.60785 3.24844 7.28285 2.96875 8.00004 2.96875C8.71723 2.96875 9.39223 3.24844 9.90004 3.75625C10.4079 4.26406 10.6875 4.93906 10.6875 5.65625C10.6875 6.37344 10.4079 7.04844 9.90004 7.55625C9.39223 8.06406 8.71723 8.34375 8.00004 8.34375Z" fill-opacity="0.88"/>
        </svg>
      </span>
    </div>
    <!-- New uploads -->
    <div *ngFor="let item of document.newUploadContractAttachments" class="mt-2 fix-width d-flex">
      <a (click)="downloadFile(item.id, item.fileName)" style="width: 90%;" class="text-truncate">
        <em class="fa fa-download fa-fw text-primary" matTooltip="{{ 'tooltips.download' | translate }}"></em>
        <span [matTooltip]="item.fileName"> {{ item.fileName }}</span>
      </a>

      <span style="width: 10%;" *ngIf="showIconAttachment">
        <svg style="outline: none;" *ngIf="item.allow == 'EXTERNAL'" matTooltip="{{('permission_attachment.config_permission' | translate) + ': ' + ('permission_attachment.all_parties_involved' | translate)}}" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.8778 11.1879C12.4867 10.7965 12.0297 10.477 11.5278 10.2441C12.2356 9.6707 12.6872 8.7957 12.6872 7.81445C12.6872 6.0832 11.2434 4.66289 9.51217 4.68945C7.80749 4.71602 6.43405 6.10508 6.43405 7.81445C6.43405 8.7957 6.88717 9.6707 7.59342 10.2441C7.0914 10.4768 6.63439 10.7963 6.24342 11.1879C5.3903 12.0426 4.90592 13.1707 4.87467 14.3738C4.87426 14.3905 4.87718 14.4071 4.88328 14.4226C4.88937 14.4382 4.89851 14.4523 4.91016 14.4642C4.92181 14.4762 4.93573 14.4857 4.95111 14.4921C4.96648 14.4986 4.98299 14.502 4.99967 14.502H5.87467C5.94186 14.502 5.99811 14.4488 5.99967 14.3816C6.02936 13.4754 6.39655 12.627 7.04186 11.9832C7.37208 11.6512 7.76486 11.388 8.19747 11.2089C8.63008 11.0297 9.09393 10.9381 9.56217 10.9395C10.5137 10.9395 11.409 11.3098 12.0825 11.9832C12.7262 12.627 13.0934 13.4754 13.1247 14.3816C13.1262 14.4488 13.1825 14.502 13.2497 14.502H14.1247C14.1414 14.502 14.1579 14.4986 14.1732 14.4921C14.1886 14.4857 14.2025 14.4762 14.2142 14.4642C14.2258 14.4523 14.235 14.4382 14.2411 14.4226C14.2472 14.4071 14.2501 14.3905 14.2497 14.3738C14.2184 13.1707 13.734 12.0426 12.8778 11.1879ZM9.56217 9.81445C9.0278 9.81445 8.52467 9.60664 8.14811 9.22852C7.95913 9.04103 7.80985 8.81739 7.70918 8.57095C7.60852 8.32451 7.55852 8.06032 7.56217 7.79414C7.56686 7.28164 7.77155 6.78633 8.12936 6.41914C8.50436 6.03477 9.00592 5.8207 9.54186 5.81445C10.0715 5.80977 10.5856 6.01602 10.9637 6.38633C11.3512 6.76602 11.5637 7.27383 11.5637 7.81445C11.5637 8.34883 11.3559 8.85039 10.9778 9.22852C10.7923 9.41492 10.5717 9.56268 10.3287 9.66325C10.0857 9.76383 9.82515 9.81522 9.56217 9.81445ZM5.64811 8.22695C5.63405 8.09102 5.62624 7.95352 5.62624 7.81445C5.62624 7.56602 5.64967 7.32383 5.69342 7.08789C5.70436 7.03164 5.67467 6.97383 5.62311 6.95039C5.41061 6.85508 5.2153 6.72383 5.04655 6.5582C4.8477 6.3654 4.69123 6.13327 4.58712 5.87661C4.483 5.61996 4.43353 5.34442 4.44186 5.06758C4.45592 4.56602 4.65749 4.08945 5.00905 3.73008C5.39499 3.33477 5.91374 3.11914 6.4653 3.12539C6.96374 3.13008 7.44499 3.32227 7.80905 3.66289C7.93249 3.77852 8.03874 3.90664 8.1278 4.04414C8.15905 4.09258 8.21999 4.11289 8.27311 4.09414C8.54811 3.99883 8.83874 3.93164 9.13717 3.90039C9.22467 3.89102 9.27467 3.79727 9.23561 3.71914C8.7278 2.71445 7.6903 2.0207 6.4903 2.00195C4.75749 1.97539 3.31374 3.3957 3.31374 5.12539C3.31374 6.10664 3.7653 6.98164 4.47311 7.55508C3.97624 7.78477 3.51842 8.10195 3.12155 8.49883C2.2653 9.35352 1.78092 10.4816 1.74967 11.6863C1.74926 11.703 1.75218 11.7196 1.75828 11.7351C1.76437 11.7507 1.77351 11.7648 1.78516 11.7767C1.79681 11.7887 1.81073 11.7982 1.8261 11.8046C1.84148 11.8111 1.85799 11.8145 1.87467 11.8145H2.75124C2.81842 11.8145 2.87467 11.7613 2.87624 11.6941C2.90592 10.7879 3.27311 9.93945 3.91842 9.2957C4.3778 8.83633 4.9403 8.51758 5.55436 8.36289C5.6153 8.34727 5.65592 8.28945 5.64811 8.22695Z" fill="black" fill-opacity="0.88"/>
        </svg>
        <svg style="outline: none;" *ngIf="item.allow == 'INTERNAL'" matTooltip="{{('permission_attachment.config_permission' | translate) + ': ' + ('permission_attachment.internal_documents' | translate)}}" [ngStyle]="{'fill': '#000000E0'}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.4141 11.9312C13.1194 11.2331 12.6916 10.5989 12.1547 10.0641C11.6195 9.52767 10.9854 9.10001 10.2875 8.80469C10.2813 8.80156 10.275 8.8 10.2688 8.79688C11.2422 8.09375 11.875 6.94844 11.875 5.65625C11.875 3.51562 10.1407 1.78125 8.00004 1.78125C5.85941 1.78125 4.12504 3.51562 4.12504 5.65625C4.12504 6.94844 4.75785 8.09375 5.73129 8.79844C5.72504 8.80156 5.71879 8.80312 5.71254 8.80625C5.01254 9.10156 4.38441 9.525 3.84535 10.0656C3.30896 10.6009 2.8813 11.235 2.58598 11.9328C2.29585 12.616 2.13939 13.3485 2.12504 14.0906C2.12462 14.1073 2.12755 14.1239 2.13364 14.1394C2.13974 14.1549 2.14888 14.1691 2.16053 14.181C2.17218 14.193 2.1861 14.2025 2.20147 14.2089C2.21684 14.2154 2.23336 14.2188 2.25004 14.2188H3.18754C3.25629 14.2188 3.31098 14.1641 3.31254 14.0969C3.34379 12.8906 3.82816 11.7609 4.68441 10.9047C5.57035 10.0188 6.74691 9.53125 8.00004 9.53125C9.25316 9.53125 10.4297 10.0188 11.3157 10.9047C12.1719 11.7609 12.6563 12.8906 12.6875 14.0969C12.6891 14.1656 12.7438 14.2188 12.8125 14.2188H13.75C13.7667 14.2188 13.7832 14.2154 13.7986 14.2089C13.814 14.2025 13.8279 14.193 13.8396 14.181C13.8512 14.1691 13.8603 14.1549 13.8664 14.1394C13.8725 14.1239 13.8755 14.1073 13.875 14.0906C13.8594 13.3438 13.7047 12.6172 13.4141 11.9312ZM8.00004 8.34375C7.28285 8.34375 6.60785 8.06406 6.10004 7.55625C5.59223 7.04844 5.31254 6.37344 5.31254 5.65625C5.31254 4.93906 5.59223 4.26406 6.10004 3.75625C6.60785 3.24844 7.28285 2.96875 8.00004 2.96875C8.71723 2.96875 9.39223 3.24844 9.90004 3.75625C10.4079 4.26406 10.6875 4.93906 10.6875 5.65625C10.6875 6.37344 10.4079 7.04844 9.90004 7.55625C9.39223 8.06406 8.71723 8.34375 8.00004 8.34375Z" fill-opacity="0.88"/>
        </svg>
      </span>
    </div>
    <span *ngIf="
        document.contractAttachments.length == 0 &&
        document.newUploadContractAttachments.length == 0
      " style="color: #858796; font-size: 14px">
      {{ "form.document_not_found" | translate }}
    </span>
    <!-- <hr /> -->
  </mat-expansion-panel>
  <!-- END: Updated for change request SCONTRACT-5260 -->

  <hr />
  <!-- Hợp đồng/văn bản liên kết -->
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="!isNegotiate" *ngIf="document.parents && document.parents.length > 0 && goFrom !== 'share'">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.digital_contract.document_parent" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #editRowInternalTable nzBordered [nzData]="document.parents" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
              "enterprise_contract.panel_document.table_users.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="70%">
            {{
              "form.digital_contract.document_information"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
          <th class="text-center">
            <!--                        {{-->
            <!--                          "enterprise_contract.panel_document.table_users.header.action"-->
            <!--                            | translate-->
            <!--                        }}-->
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell d-flex align-items-center">
              <div style="margin-right: 12px;">
                <svg *ngIf="data.isContractShare" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.breadcrumb' | translate}}">
                  <path d="M9 8.54C8.62 8.54 8.28 8.69 8.02 8.925L4.455 6.85C4.48 6.735 4.5 6.62 4.5 6.5C4.5 6.38 4.48 6.265 4.455 6.15L7.98 4.095C8.25 4.345 8.605 4.5 9 4.5C9.83 4.5 10.5 3.83 10.5 3C10.5 2.17 9.83 1.5 9 1.5C8.17 1.5 7.5 2.17 7.5 3C7.5 3.12 7.52 3.235 7.545 3.35L4.02 5.405C3.75 5.155 3.395 5 3 5C2.17 5 1.5 5.67 1.5 6.5C1.5 7.33 2.17 8 3 8C3.395 8 3.75 7.845 4.02 7.595L7.58 9.675C7.555 9.78 7.54 9.89 7.54 10C7.54 10.805 8.195 11.46 9 11.46C9.805 11.46 10.46 10.805 10.46 10C10.46 9.195 9.805 8.54 9 8.54Z" fill="black"/>
                </svg>
                <svg *ngIf="!data.isContractShare" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.internal_contract' | translate}}">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.99894 0.5H9.95711L12 2.54289V12.5H8.5V11.5H11V4H8.5V1.5H2.99894V4H1.99894V0.5ZM9.5 1.5V3H11V2.95711L9.54289 1.5H9.5ZM4.5 6C3.94772 6 3.5 6.44772 3.5 7V7.5H5.5V7C5.5 6.44772 5.05228 6 4.5 6ZM6.5 7.5V7C6.5 5.89543 5.60457 5 4.5 5C3.39543 5 2.5 5.89543 2.5 7V7.5H1.5V12.5H7.5V7.5H6.5ZM6.5 8.5H2.5V11.5H6.5V8.5ZM5 9.5V10.5H4V9.5H5Z" fill="black"/>
                </svg>
              </div>
              <div class="row-icon" style="flex: 1;" [ngStyle]="{ 'text-decoration': data.isRevokeContractShare ? 'line-through' : 'none'}"> {{ data.code }}
                - {{ data.name }}
              </div>
              <div *ngIf="data.isRevokeContractShare || (!checkPermissionLimitedViewContract() && data.isContractShare)" style="height: 20px;">
                <svg matTooltip="{{ (data.isRevokeContractShare ? 'contract_share_partner.revoked_tooltip' : 'contract_share_partner.no_permission_tooltip') | translate }}" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.125 6.3125C1.125 3.72391 3.22391 1.625 5.8125 1.625C8.40109 1.625 10.5 3.72391 10.5 6.3125C10.5 8.90109 8.40109 11 5.8125 11C3.22391 11 1.125 8.90109 1.125 6.3125ZM5.8125 2.375C3.63812 2.375 1.875 4.13812 1.875 6.3125C1.875 8.48688 3.63812 10.25 5.8125 10.25C7.98688 10.25 9.75 8.48688 9.75 6.3125C9.75 4.13812 7.98688 2.375 5.8125 2.375Z" fill="#CD002A"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.78125 5.65625C4.78125 5.44914 4.94914 5.28125 5.15625 5.28125H5.90625C6.11336 5.28125 6.28125 5.44914 6.28125 5.65625V8.375C6.28125 8.58211 6.11336 8.75 5.90625 8.75C5.69914 8.75 5.53125 8.58211 5.53125 8.375V6.03125H5.15625C4.94914 6.03125 4.78125 5.86336 4.78125 5.65625Z" fill="#CD002A"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 8.46875C4.5 8.26164 4.66789 8.09375 4.875 8.09375H6.9375C7.14461 8.09375 7.3125 8.26164 7.3125 8.46875C7.3125 8.67586 7.14461 8.84375 6.9375 8.84375H4.875C4.66789 8.84375 4.5 8.67586 4.5 8.46875Z" fill="#CD002A"/>
                  <path d="M5.8125 3.54688C5.69198 3.54688 5.57416 3.58261 5.47395 3.64957C5.37374 3.71653 5.29563 3.8117 5.24951 3.92305C5.20339 4.0344 5.19132 4.15693 5.21483 4.27513C5.23835 4.39334 5.29638 4.50192 5.38161 4.58714C5.46683 4.67237 5.57541 4.7304 5.69362 4.75392C5.81182 4.77743 5.93435 4.76536 6.0457 4.71924C6.15705 4.67312 6.25222 4.59501 6.31918 4.4948C6.38614 4.39459 6.42188 4.27677 6.42188 4.15625C6.42188 3.99463 6.35767 3.83964 6.24339 3.72536C6.12911 3.61108 5.97412 3.54688 5.8125 3.54688Z" fill="#CD002A"/>
                </svg>
              </div>
            </div>
          </td>
          <td class="text-center">
            <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
            <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
            <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
            <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
            <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
            <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
            <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
            <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
            <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
            <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
            <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
          </td>
          <!-- Action -->
          <td class="td-nz-icon text-center">
            <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id && (!data.isRevokeContractShare && !(!checkPermissionLimitedViewContract() && data.isContractShare)); else noPermission" aria-label="View" style="color: #07736C">
              <mat-icon>
                visibility
              </mat-icon>
            </button>
            <ng-template #noPermission>
              <button mat-icon-button disabled>
                <span> </span>
              </button>
            </ng-template>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #contentEmptyTable let-name></ng-template>
